
var $a0b4f895e1596b3b$exports = {};
!function(a) {
    "use strict";
    function t(a, t, r) {
        return r.a = a, r.f = t, r;
    }
    function F2(a) {
        return t(2, a, function(t) {
            return function(r) {
                return a(t, r);
            };
        });
    }
    function F3(a) {
        return t(3, a, function(t) {
            return function(r) {
                return function(n) {
                    return a(t, r, n);
                };
            };
        });
    }
    function F4(a) {
        return t(4, a, function(t) {
            return function(r) {
                return function(n) {
                    return function(e) {
                        return a(t, r, n, e);
                    };
                };
            };
        });
    }
    function F5(a) {
        return t(5, a, function(t) {
            return function(r) {
                return function(n) {
                    return function(e) {
                        return function(c) {
                            return a(t, r, n, e, c);
                        };
                    };
                };
            };
        });
    }
    function F6(a) {
        return t(6, a, function(t) {
            return function(r) {
                return function(n) {
                    return function(e) {
                        return function(c) {
                            return function(i) {
                                return a(t, r, n, e, c, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(a) {
        return t(7, a, function(t) {
            return function(r) {
                return function(n) {
                    return function(e) {
                        return function(c) {
                            return function(i) {
                                return function(u) {
                                    return a(t, r, n, e, c, i, u);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(a, t, r) {
        return 2 === a.a ? a.f(t, r) : a(t)(r);
    }
    function A3(a, t, r, n) {
        return 3 === a.a ? a.f(t, r, n) : a(t)(r)(n);
    }
    function A4(a, t, r, n, e) {
        return 4 === a.a ? a.f(t, r, n, e) : a(t)(r)(n)(e);
    }
    function A5(a, t, r, n, e, c) {
        return 5 === a.a ? a.f(t, r, n, e, c) : a(t)(r)(n)(e)(c);
    }
    function A6(a, t, r, n, e, c, i) {
        return 6 === a.a ? a.f(t, r, n, e, c, i) : a(t)(r)(n)(e)(c)(i);
    }
    function A7(a, t, r, n, e, c, i, u) {
        return 7 === a.a ? a.f(t, r, n, e, c, i, u) : a(t)(r)(n)(e)(c)(i)(u);
    }
    function r(a, t) {
        for(var r, e = [], c = n(a, t, 0, e); c && (r = e.pop()); c = n(r.a, r.b, 0, e));
        return c;
    }
    function n(a, t, r, e) {
        if (a === t) return !0;
        if ("object" != typeof a || null === a || null === t) return "function" == typeof a && m(5), !1;
        if (r > 100) return e.push(i(a, t)), !0;
        for(var c in 0 > a.$ && (a = wt(a), t = wt(t)), a)if (!n(a[c], t[c], r + 1, e)) return !1;
        return !0;
    }
    function e(a, t, r) {
        if ("object" != typeof a) return a === t ? 0 : t > a ? -1 : 1;
        if (void 0 === a.$) return (r = e(a.a, t.a)) || (r = e(a.b, t.b)) ? r : e(a.c, t.c);
        for(; a.b && t.b && !(r = e(a.a, t.a)); a = a.b, t = t.b);
        return r || (a.b ? 1 : t.b ? -1 : 0);
    }
    var c = F2(function(a, t) {
        var r = e(a, t);
        return 0 > r ? Pt : r ? It : Wt;
    });
    function i(a, t) {
        return {
            a: a,
            b: t
        };
    }
    function u(a, t) {
        var r = {};
        for(var n in a)r[n] = a[n];
        for(var n in t)r[n] = t[n];
        return r;
    }
    function o(a, t) {
        if ("string" == typeof a) return a + t;
        if (!a.b) return t;
        var r = b(a.a, t);
        a = a.b;
        for(var n = r; a.b; a = a.b)n = n.b = b(a.a, t);
        return r;
    }
    var f = {
        $: 0
    };
    function b(a, t) {
        return {
            $: 1,
            a: a,
            b: t
        };
    }
    var v = F2(b);
    function s(a) {
        for(var t = f, r = a.length; r--;)t = b(a[r], t);
        return t;
    }
    var g = F3(function(a, t, r) {
        for(var n = []; t.b && r.b; t = t.b, r = r.b)n.push(A2(a, t.a, r.a));
        return s(n);
    }), d = F4(function(a, t, r, n) {
        for(var e = []; t.b && r.b && n.b; t = t.b, r = r.b, n = n.b)e.push(A3(a, t.a, r.a, n.a));
        return s(e);
    }), h = F3(function(a, t, r) {
        for(var n = Array(a), e = 0; a > e; e++)n[e] = r(t + e);
        return n;
    }), l = F2(function(a, t) {
        for(var r = Array(a), n = 0; a > n && t.b; n++)r[n] = t.a, t = t.b;
        return r.length = n, i(r, t);
    });
    function m(a) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + a + ".md");
    }
    var p = F2(function(a, t) {
        return a + t;
    }), j = Math.ceil, W = Math.floor, I = Math.round, P = Math.log, $ = F2(function(a, t) {
        return t.split(a);
    }), y = F3(function(a, t, r) {
        return r.slice(a, t);
    }), w = F2(function(a, t) {
        return t.indexOf(a) > -1;
    }), k = F2(function(a, t) {
        return 0 === t.indexOf(a);
    }), A = F2(function(a, t) {
        var r = a.length;
        if (1 > r) return f;
        for(var n = 0, e = []; (n = t.indexOf(a, n)) > -1;)e.push(n), n += r;
        return s(e);
    });
    function x(a) {
        return a + "";
    }
    function L(a) {
        return {
            $: 2,
            b: a
        };
    }
    L(function(a) {
        return "number" != typeof a ? F("an INT", a) : a > -2147483647 && 2147483647 > a && (0 | a) === a ? Et(a) : !isFinite(a) || a % 1 ? F("an INT", a) : Et(a);
    }), L(function(a) {
        return "boolean" == typeof a ? Et(a) : F("a BOOL", a);
    });
    var E = L(function(a) {
        return "number" == typeof a ? Et(a) : F("a FLOAT", a);
    }), M = (L(function(a) {
        return Et(a);
    }), L(function(a) {
        return "string" == typeof a ? Et(a) : a instanceof String ? Et(a + "") : F("a STRING", a);
    })), N = F2(function(a, t) {
        return {
            $: 6,
            d: a,
            b: t
        };
    });
    var O = F2(function(a, t) {
        return {
            $: 10,
            b: t,
            h: a
        };
    }), T = F2(function(a, t) {
        return function(a, t) {
            return {
                $: 9,
                f: a,
                g: t
            };
        }(a, [
            t
        ]);
    }), C = F2(function(a, t) {
        return _(a, t);
    });
    function _(a, t) {
        switch(a.$){
            case 2:
                return a.b(t);
            case 5:
                return null === t ? Et(a.c) : F("null", t);
            case 3:
                return H(t) ? R(a.b, t, s) : F("a LIST", t);
            case 4:
                return H(t) ? R(a.b, t, z) : F("an ARRAY", t);
            case 6:
                var r = a.d;
                if ("object" != typeof t || null === t || !(r in t)) return F("an OBJECT with a field named `" + r + "`", t);
                var n = _(a.b, t[r]);
                return vr(n) ? n : kt(A2(xt, r, n.a));
            case 7:
                var e = a.e;
                return H(t) ? t.length > e ? (n = _(a.b, t[e]), vr(n) ? n : kt(A2(Lt, e, n.a))) : F("a LONGER array. Need index " + e + " but only see " + t.length + " entries", t) : F("an ARRAY", t);
            case 8:
                if ("object" != typeof t || null === t || H(t)) return F("an OBJECT", t);
                var c = f;
                for(var u in t)if (t.hasOwnProperty(u)) {
                    if (n = _(a.b, t[u]), !vr(n)) return kt(A2(xt, u, n.a));
                    c = b(i(u, n.a), c);
                }
                return Et(Xt(c));
            case 9:
                for(var o = a.f, v = a.g, g = 0; v.length > g; g++){
                    if (n = _(v[g], t), !vr(n)) return n;
                    o = o(n.a);
                }
                return Et(o);
            case 10:
                return n = _(a.b, t), vr(n) ? _(a.h(n.a), t) : n;
            case 11:
                for(var d = f, h = a.g; h.b; h = h.b){
                    if (n = _(h.a, t), vr(n)) return n;
                    d = b(n.a, d);
                }
                return kt(Mt(Xt(d)));
            case 1:
                return kt(A2(At, a.a, t));
            case 0:
                return Et(a.a);
        }
    }
    function R(a, t, r) {
        for(var n = t.length, e = Array(n), c = 0; n > c; c++){
            var i = _(a, t[c]);
            if (!vr(i)) return kt(A2(Lt, c, i.a));
            e[c] = i.a;
        }
        return Et(r(e));
    }
    function H(a) {
        return Array.isArray(a) || "function" == typeof FileList && a instanceof FileList;
    }
    function z(a) {
        return A2(br, a.length, function(t) {
            return a[t];
        });
    }
    function F(a, t) {
        return kt(A2(At, "Expecting " + a, t));
    }
    function S(a, t) {
        if (a === t) return !0;
        if (a.$ !== t.$) return !1;
        switch(a.$){
            case 0:
            case 1:
                return a.a === t.a;
            case 2:
                return a.b === t.b;
            case 5:
                return a.c === t.c;
            case 3:
            case 4:
            case 8:
                return S(a.b, t.b);
            case 6:
                return a.d === t.d && S(a.b, t.b);
            case 7:
                return a.e === t.e && S(a.b, t.b);
            case 9:
                return a.f === t.f && q(a.g, t.g);
            case 10:
                return a.h === t.h && S(a.b, t.b);
            case 11:
                return q(a.g, t.g);
        }
    }
    function q(a, t) {
        var r = a.length;
        if (r !== t.length) return !1;
        for(var n = 0; r > n; n++)if (!S(a[n], t[n])) return !1;
        return !0;
    }
    var J = F2(function(a, t) {
        return JSON.stringify(t, null, a) + "";
    });
    function X(a) {
        return a;
    }
    var Y = F3(function(a, t, r) {
        return r[a] = t, r;
    });
    function Z(a) {
        return {
            $: 0,
            a: a
        };
    }
    function B(a) {
        return {
            $: 2,
            b: a,
            c: null
        };
    }
    var V = F2(function(a, t) {
        return {
            $: 3,
            b: a,
            d: t
        };
    }), U = F2(function(a, t) {
        return {
            $: 4,
            b: a,
            d: t
        };
    }), K = 0;
    function D(a) {
        var t = {
            $: 0,
            e: K++,
            f: a,
            g: null,
            h: []
        };
        return na(t), t;
    }
    function G(a) {
        return B(function(t) {
            t(Z(D(a)));
        });
    }
    function Q(a, t) {
        a.h.push(t), na(a);
    }
    var aa = F2(function(a, t) {
        return B(function(r) {
            Q(a, t), r(Z(0));
        });
    }), ta = !1, ra = [];
    function na(a) {
        if (ra.push(a), !ta) {
            for(ta = !0; a = ra.shift();)ea(a);
            ta = !1;
        }
    }
    function ea(a) {
        for(; a.f;){
            var t = a.f.$;
            if (0 === t || 1 === t) {
                for(; a.g && a.g.$ !== t;)a.g = a.g.i;
                if (!a.g) return;
                a.f = a.g.b(a.f.a), a.g = a.g.i;
            } else {
                if (2 === t) return void (a.f.c = a.f.b(function(t) {
                    a.f = t, na(a);
                }));
                if (5 === t) {
                    if (0 === a.h.length) return;
                    a.f = a.f.b(a.h.shift());
                } else a.g = {
                    $: 3 === t ? 0 : 1,
                    b: a.f.b,
                    i: a.g
                }, a.f = a.f.d;
            }
        }
    }
    var ca = {};
    function ia(a, t, r, n, e) {
        return {
            b: a,
            c: t,
            d: r,
            e: n,
            f: e
        };
    }
    function ua(a, t) {
        var r = {
            g: t,
            h: void 0
        }, n = a.c, e = a.d, c = a.e, i = a.f;
        function u(a) {
            return A2(V, u, {
                $: 5,
                b: function(t) {
                    var u = t.a;
                    return 0 === t.$ ? A3(e, r, u, a) : c && i ? A4(n, r, u.i, u.j, a) : A3(n, r, c ? u.i : u.j, a);
                }
            });
        }
        return r.h = D(A2(V, u, a.b));
    }
    var oa = F2(function(a, t) {
        return B(function(r) {
            a.g(t), r(Z(0));
        });
    }), fa = F2(function(a, t) {
        return A2(aa, a.h, {
            $: 0,
            a: t
        });
    });
    function ba(a) {
        return function(t) {
            return {
                $: 1,
                k: a,
                l: t
            };
        };
    }
    var va = [], sa = !1;
    function ga(a, t, r) {
        if (va.push({
            p: a,
            q: t,
            r: r
        }), !sa) {
            sa = !0;
            for(var n; n = va.shift();)da(n.p, n.q, n.r);
            sa = !1;
        }
    }
    function da(a, t, r) {
        var n = {};
        for(var e in ha(!0, t, n, null), ha(!1, r, n, null), a)Q(a[e], {
            $: "fx",
            a: n[e] || {
                i: f,
                j: f
            }
        });
    }
    function ha(a, t, r, n) {
        switch(t.$){
            case 1:
                var e = t.k, c = function(a, t, r, n) {
                    function e(a) {
                        for(var t = r; t; t = t.t)a = t.s(a);
                        return a;
                    }
                    return A2(a ? ca[t].e : ca[t].f, e, n);
                }(a, e, n, t.l);
                return void (r[e] = function(a, t, r) {
                    return r = r || {
                        i: f,
                        j: f
                    }, a ? r.i = b(t, r.i) : r.j = b(t, r.j), r;
                }(a, c, r[e]));
            case 2:
                for(var i = t.m; i.b; i = i.b)ha(a, i.a, r, n);
                return;
            case 3:
                return void ha(a, t.o, r, {
                    s: t.n,
                    t: n
                });
        }
    }
    var la, ma = F2(function(a, t) {
        return function(r) {
            return a(t(r));
        };
    });
    var pa = "undefined" != typeof document ? document : {};
    function ja(a, t) {
        a.appendChild(t);
    }
    function Wa(a) {
        return {
            $: 0,
            a: a
        };
    }
    var Ia, Pa = F2(function(a, t) {
        return F2(function(r, n) {
            for(var e = [], c = 0; n.b; n = n.b){
                var i = n.a;
                c += i.b || 0, e.push(i);
            }
            return c += e.length, {
                $: 1,
                c: t,
                d: Na(r),
                e: e,
                f: a,
                b: c
            };
        });
    }), $a = Pa(void 0), ya = F2(function(a, t) {
        return F2(function(r, n) {
            for(var e = [], c = 0; n.b; n = n.b){
                var i = n.a;
                c += i.b.b || 0, e.push(i);
            }
            return c += e.length, {
                $: 2,
                c: t,
                d: Na(r),
                e: e,
                f: a,
                b: c
            };
        });
    })(void 0), wa = F2(function(a, t) {
        return {
            $: "a0",
            n: a,
            o: t
        };
    }), ka = F2(function(a, t) {
        return {
            $: "a1",
            n: a,
            o: t
        };
    }), Aa = F2(function(a, t) {
        return {
            $: "a2",
            n: a,
            o: t
        };
    }), xa = F2(function(a, t) {
        return {
            $: "a3",
            n: a,
            o: t
        };
    }), La = F3(function(a, t, r) {
        return {
            $: "a4",
            n: t,
            o: {
                f: a,
                o: r
            }
        };
    });
    function Ea(a) {
        return "script" == a ? "p" : a;
    }
    function Ma(a) {
        return /^\s*(javascript:|data:text\/html)/i.test(a) ? "" : a;
    }
    function Na(a) {
        for(var t = {}; a.b; a = a.b){
            var r = a.a, n = r.$, e = r.n, c = r.o;
            if ("a2" !== n) {
                var i = t[n] || (t[n] = {});
                "a3" === n && "class" === e ? Oa(i, e, c) : i[e] = c;
            } else "className" === e ? Oa(t, e, X(c)) : t[e] = X(c);
        }
        return t;
    }
    function Oa(a, t, r) {
        var n = a[t];
        a[t] = n ? n + " " + r : r;
    }
    function Ta(a, t) {
        var r = a.$;
        if (5 === r) return Ta(a.k || (a.k = a.m()), t);
        if (0 === r) return pa.createTextNode(a.a);
        if (4 === r) {
            for(var n = a.k, e = a.j; 4 === n.$;)"object" != typeof e ? e = [
                e,
                n.j
            ] : e.push(n.j), n = n.k;
            var c = {
                j: e,
                p: t
            };
            return (i = Ta(n, c)).elm_event_node_ref = c, i;
        }
        if (3 === r) return Ca(i = a.h(a.g), t, a.d), i;
        var i = a.f ? pa.createElementNS(a.f, a.c) : pa.createElement(a.c);
        la && "a" == a.c && i.addEventListener("click", la(i)), Ca(i, t, a.d);
        for(var u = a.e, o = 0; u.length > o; o++)ja(i, Ta(1 === r ? u[o] : u[o].b, t));
        return i;
    }
    function Ca(a, t, r) {
        for(var n in r){
            var e = r[n];
            "a1" === n ? _a(a, e) : "a0" === n ? za(a, t, e) : "a3" === n ? Ra(a, e) : "a4" === n ? Ha(a, e) : ("value" !== n && "checked" !== n || a[n] !== e) && (a[n] = e);
        }
    }
    function _a(a, t) {
        var r = a.style;
        for(var n in t)r[n] = t[n];
    }
    function Ra(a, t) {
        for(var r in t){
            var n = t[r];
            void 0 !== n ? a.setAttribute(r, n) : a.removeAttribute(r);
        }
    }
    function Ha(a, t) {
        for(var r in t){
            var n = t[r], e = n.f, c = n.o;
            void 0 !== c ? a.setAttributeNS(e, r, c) : a.removeAttributeNS(e, r);
        }
    }
    function za(a, t, r) {
        var n = a.elmFs || (a.elmFs = {});
        for(var e in r){
            var c = r[e], i = n[e];
            if (c) {
                if (i) {
                    if (i.q.$ === c.$) {
                        i.q = c;
                        continue;
                    }
                    a.removeEventListener(e, i);
                }
                i = Fa(t, c), a.addEventListener(e, i, Ia && {
                    passive: 2 > dr(c)
                }), n[e] = i;
            } else a.removeEventListener(e, i), n[e] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Ia = !0;
            }
        }));
    } catch (a) {}
    function Fa(a, t) {
        function r(t) {
            var n = r.q, e = _(n.a, t);
            if (vr(e)) {
                for(var c, i = dr(n), u = e.a, o = i ? 3 > i ? u.a : u.cg : u, f = 1 == i ? u.b : 3 == i && u.aD, b = (f && t.stopPropagation(), (2 == i ? u.b : 3 == i && u.aA) && t.preventDefault(), a); c = b.j;){
                    if ("function" == typeof c) o = c(o);
                    else for(var v = c.length; v--;)o = c[v](o);
                    b = b.p;
                }
                b(o, f);
            }
        }
        return r.q = t, r;
    }
    function Sa(a, t) {
        return a.$ == t.$ && S(a.a, t.a);
    }
    function qa(a, t, r, n) {
        var e = {
            $: t,
            r: r,
            s: n,
            t: void 0,
            u: void 0
        };
        return a.push(e), e;
    }
    function Ja(a, t, r, n) {
        if (a !== t) {
            var e = a.$, c = t.$;
            if (e !== c) {
                if (1 !== e || 2 !== c) return void qa(r, 0, n, t);
                t = function(a) {
                    for(var t = a.e, r = t.length, n = Array(r), e = 0; r > e; e++)n[e] = t[e].b;
                    return {
                        $: 1,
                        c: a.c,
                        d: a.d,
                        e: n,
                        f: a.f,
                        b: a.b
                    };
                }(t), c = 1;
            }
            switch(c){
                case 5:
                    for(var i = a.l, u = t.l, o = i.length, f = o === u.length; f && o--;)f = i[o] === u[o];
                    if (f) return void (t.k = a.k);
                    t.k = t.m();
                    var b = [];
                    return Ja(a.k, t.k, b, 0), void (b.length > 0 && qa(r, 1, n, b));
                case 4:
                    for(var v = a.j, s = t.j, g = !1, d = a.k; 4 === d.$;)g = !0, "object" != typeof v ? v = [
                        v,
                        d.j
                    ] : v.push(d.j), d = d.k;
                    for(var h = t.k; 4 === h.$;)g = !0, "object" != typeof s ? s = [
                        s,
                        h.j
                    ] : s.push(h.j), h = h.k;
                    return g && v.length !== s.length ? void qa(r, 0, n, t) : ((g ? function(a, t) {
                        for(var r = 0; a.length > r; r++)if (a[r] !== t[r]) return !1;
                        return !0;
                    }(v, s) : v === s) || qa(r, 2, n, s), void Ja(d, h, r, n + 1));
                case 0:
                    return void (a.a !== t.a && qa(r, 3, n, t.a));
                case 1:
                    return void Xa(a, t, r, n, Za);
                case 2:
                    return void Xa(a, t, r, n, Ba);
                case 3:
                    if (a.h !== t.h) return void qa(r, 0, n, t);
                    var l = Ya(a.d, t.d);
                    l && qa(r, 4, n, l);
                    var m = t.i(a.g, t.g);
                    return void (m && qa(r, 5, n, m));
            }
        }
    }
    function Xa(a, t, r, n, e) {
        if (a.c === t.c && a.f === t.f) {
            var c = Ya(a.d, t.d);
            c && qa(r, 4, n, c), e(a, t, r, n);
        } else qa(r, 0, n, t);
    }
    function Ya(a, t, r) {
        var n;
        for(var e in a)if ("a1" !== e && "a0" !== e && "a3" !== e && "a4" !== e) {
            if (e in t) {
                var c = a[e], i = t[e];
                c === i && "value" !== e && "checked" !== e || "a0" === r && Sa(c, i) || ((n = n || {})[e] = i);
            } else (n = n || {})[e] = r ? "a1" === r ? "" : "a0" === r || "a3" === r ? void 0 : {
                f: a[e].f,
                o: void 0
            } : "string" == typeof a[e] ? "" : null;
        } else {
            var u = Ya(a[e], t[e] || {}, e);
            u && ((n = n || {})[e] = u);
        }
        for(var o in t)o in a || ((n = n || {})[o] = t[o]);
        return n;
    }
    function Za(a, t, r, n) {
        var e = a.e, c = t.e, i = e.length, u = c.length;
        i > u ? qa(r, 6, n, {
            v: u,
            i: i - u
        }) : u > i && qa(r, 7, n, {
            v: i,
            e: c
        });
        for(var o = u > i ? i : u, f = 0; o > f; f++){
            var b = e[f];
            Ja(b, c[f], r, ++n), n += b.b || 0;
        }
    }
    function Ba(a, t, r, n) {
        for(var e = [], c = {}, i = [], u = a.e, o = t.e, f = u.length, b = o.length, v = 0, s = 0, g = n; f > v && b > s;){
            var d = (k = u[v]).a, h = (A = o[s]).a, l = k.b, m = A.b, p = void 0, j = void 0;
            if (d !== h) {
                var W = u[v + 1], I = o[s + 1];
                if (W) {
                    var P = W.a, $ = W.b;
                    j = h === P;
                }
                if (I) {
                    var y = I.a, w = I.b;
                    p = d === y;
                }
                if (p && j) Ja(l, w, e, ++g), Ua(c, e, d, m, s, i), g += l.b || 0, Ka(c, e, d, $, ++g), g += $.b || 0, v += 2, s += 2;
                else if (p) g++, Ua(c, e, h, m, s, i), Ja(l, w, e, g), g += l.b || 0, v += 1, s += 2;
                else if (j) Ka(c, e, d, l, ++g), g += l.b || 0, Ja($, m, e, ++g), g += $.b || 0, v += 2, s += 1;
                else {
                    if (!W || P !== y) break;
                    Ka(c, e, d, l, ++g), Ua(c, e, h, m, s, i), g += l.b || 0, Ja($, w, e, ++g), g += $.b || 0, v += 2, s += 2;
                }
            } else Ja(l, m, e, ++g), g += l.b || 0, v++, s++;
        }
        for(; f > v;){
            var k;
            g++, Ka(c, e, (k = u[v]).a, l = k.b, g), g += l.b || 0, v++;
        }
        for(; b > s;){
            var A, x = x || [];
            Ua(c, e, (A = o[s]).a, A.b, void 0, x), s++;
        }
        (e.length > 0 || i.length > 0 || x) && qa(r, 8, n, {
            w: e,
            x: i,
            y: x
        });
    }
    var Va = "_elmW6BL";
    function Ua(a, t, r, n, e, c) {
        var i = a[r];
        if (!i) return c.push({
            r: e,
            A: i = {
                c: 0,
                z: n,
                r: e,
                s: void 0
            }
        }), void (a[r] = i);
        if (1 === i.c) {
            c.push({
                r: e,
                A: i
            }), i.c = 2;
            var u = [];
            return Ja(i.z, n, u, i.r), i.r = e, void (i.s.s = {
                w: u,
                A: i
            });
        }
        Ua(a, t, r + Va, n, e, c);
    }
    function Ka(a, t, r, n, e) {
        var c = a[r];
        if (c) {
            if (0 === c.c) {
                c.c = 2;
                var i = [];
                return Ja(n, c.z, i, e), void qa(t, 9, e, {
                    w: i,
                    A: c
                });
            }
            Ka(a, t, r + Va, n, e);
        } else {
            var u = qa(t, 9, e, void 0);
            a[r] = {
                c: 1,
                z: n,
                r: e,
                s: u
            };
        }
    }
    function Da(a, t, r, n) {
        Ga(a, t, r, 0, 0, t.b, n);
    }
    function Ga(a, t, r, n, e, c, i) {
        for(var u = r[n], o = u.r; o === e;){
            var f = u.$;
            if (1 === f) Da(a, t.k, u.s, i);
            else if (8 === f) u.t = a, u.u = i, (b = u.s.w).length > 0 && Ga(a, t, b, 0, e, c, i);
            else if (9 === f) {
                u.t = a, u.u = i;
                var b, v = u.s;
                v && (v.A.s = a, (b = v.w).length > 0 && Ga(a, t, b, 0, e, c, i));
            } else u.t = a, u.u = i;
            if (!(u = r[++n]) || (o = u.r) > c) return n;
        }
        var s = t.$;
        if (4 === s) {
            for(var g = t.k; 4 === g.$;)g = g.k;
            return Ga(a, g, r, n, e + 1, c, a.elm_event_node_ref);
        }
        for(var d = t.e, h = a.childNodes, l = 0; d.length > l; l++){
            e++;
            var m = 1 === s ? d[l] : d[l].b, p = e + (m.b || 0);
            if (!(e > o || o > p || (u = r[n = Ga(h[l], m, r, n, e, p, i)]) && (o = u.r) <= c)) return n;
            e = p;
        }
        return n;
    }
    function Qa(a, t) {
        for(var r = 0; t.length > r; r++){
            var n = t[r], e = n.t, c = at(e, n);
            e === a && (a = c);
        }
        return a;
    }
    function at(a, t) {
        switch(t.$){
            case 0:
                return function(a, t, r) {
                    var n = a.parentNode, e = Ta(t, r);
                    return e.elm_event_node_ref || (e.elm_event_node_ref = a.elm_event_node_ref), n && e !== a && n.replaceChild(e, a), e;
                }(a, t.s, t.u);
            case 4:
                return Ca(a, t.u, t.s), a;
            case 3:
                return a.replaceData(0, a.length, t.s), a;
            case 1:
                return Qa(a, t.s);
            case 2:
                return a.elm_event_node_ref ? a.elm_event_node_ref.j = t.s : a.elm_event_node_ref = {
                    j: t.s,
                    p: t.u
                }, a;
            case 6:
                for(var r = t.s, n = 0; r.i > n; n++)a.removeChild(a.childNodes[r.v]);
                return a;
            case 7:
                for(var e = (r = t.s).e, c = a.childNodes[n = r.v]; e.length > n; n++)a.insertBefore(Ta(e[n], t.u), c);
                return a;
            case 9:
                if (!(r = t.s)) return a.parentNode.removeChild(a), a;
                var i = r.A;
                return void 0 !== i.r && a.parentNode.removeChild(a), i.s = Qa(a, r.w), a;
            case 8:
                return function(a, t) {
                    var r = t.s, n = function(a, t) {
                        if (a) {
                            for(var r = pa.createDocumentFragment(), n = 0; a.length > n; n++){
                                var e = a[n].A;
                                ja(r, 2 === e.c ? e.s : Ta(e.z, t.u));
                            }
                            return r;
                        }
                    }(r.y, t);
                    a = Qa(a, r.w);
                    for(var e = r.x, c = 0; e.length > c; c++){
                        var i = e[c], u = i.A, o = 2 === u.c ? u.s : Ta(u.z, t.u);
                        a.insertBefore(o, a.childNodes[i.r]);
                    }
                    return n && ja(a, n), a;
                }(a, t);
            case 5:
                return t.s(a);
            default:
                m(10);
        }
    }
    function tt(a) {
        if (3 === a.nodeType) return Wa(a.textContent);
        if (1 !== a.nodeType) return Wa("");
        for(var t = f, r = a.attributes, n = r.length; n--;){
            var e = r[n];
            t = b(A2(xa, e.name, e.value), t);
        }
        var c = a.tagName.toLowerCase(), i = f, u = a.childNodes;
        for(n = u.length; n--;)i = b(tt(u[n]), i);
        return A3($a, c, t, i);
    }
    var rt = F4(function(a, t, r, n) {
        return function(a, t, r, n, e, c) {
            var i = A2(C, a, t ? t.flags : void 0);
            vr(i) || m(2);
            var u = {}, o = (i = r(i.a)).a, f = c(v, o), b = function(a, t) {
                var r;
                for(var n in ca){
                    var e = ca[n];
                    e.a && ((r = r || {})[n] = e.a(n, t)), a[n] = ua(e, t);
                }
                return r;
            }(u, v);
            function v(a, t) {
                f(o = (i = A2(n, a, o)).a, t), ga(u, i.b, e(o));
            }
            return ga(u, i.b, e(o)), b ? {
                ports: b
            } : {};
        }(t, n, a.b7, a.cX, a.cQ, function(t, r) {
            var n = a.aB && a.aB(t), e = a.c_, c = pa.title, i = pa.body, u = tt(i);
            return function(a, t) {
                t(a);
                var r = 0;
                function n() {
                    r = 1 === r ? 0 : (nt(n), t(a), 1);
                }
                return function(e, c) {
                    a = e, c ? (t(a), 2 === r && (r = 1)) : (0 === r && nt(n), r = 2);
                };
            }(r, function(a) {
                la = n;
                var r = e(a), o = $a("body")(f)(r.bE), b = function(a, t) {
                    var r = [];
                    return Ja(a, t, r, 0), r;
                }(u, o);
                i = function(a, t, r, n) {
                    return 0 === r.length ? a : (Da(a, t, r, n), Qa(a, r));
                }(i, u, b, t), u = o, la = 0, c !== r.cV && (pa.title = c = r.cV);
            });
        });
    }), nt = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(a) {
        return setTimeout(a, 1e3 / 60);
    });
    function et() {
        return Lr(pa.location.href).a || m(1);
    }
    var ct = F2(function(a, t) {
        return A2(Zr, Er, B(function() {
            history.pushState({}, "", t), a();
        }));
    }), it = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, ut = "undefined" != typeof document ? document : it, ot = "undefined" != typeof window ? window : it;
    function ft(a, t) {
        return B(function(r) {
            nt(function() {
                var n = document.getElementById(a);
                r(n ? Z(t(n)) : {
                    $: 1,
                    a: lr(a)
                });
            });
        });
    }
    function bt(a) {
        return B(function(t) {
            nt(function() {
                t(Z(a()));
            });
        });
    }
    function vt() {
        var a = ut.body, t = ut.documentElement;
        return {
            c0: Math.max(a.scrollWidth, a.offsetWidth, t.scrollWidth, t.offsetWidth, t.clientWidth),
            aW: Math.max(a.scrollHeight, a.offsetHeight, t.scrollHeight, t.offsetHeight, t.clientHeight)
        };
    }
    var st = F2(function(a, t) {
        return bt(function() {
            return ot.scroll(a, t), 0;
        });
    }), gt = F3(function(a, t, r) {
        return B(function(n) {
            function e(a) {
                n(t(r.bW.a(a)));
            }
            var c = new XMLHttpRequest;
            c.addEventListener("error", function() {
                e(ae);
            }), c.addEventListener("timeout", function() {
                e(ne);
            }), c.addEventListener("load", function() {
                e(function(a, t) {
                    return A2(t.status >= 200 && 300 > t.status ? Qn : Dn, function(a) {
                        return {
                            bv: a.responseURL,
                            cN: a.status,
                            cO: a.statusText,
                            aV: dt(a.getAllResponseHeaders())
                        };
                    }(t), a(t.response));
                }(r.bW.b, c));
            }), ee(r.bu) && function(a, t, r) {
                t.upload.addEventListener("progress", function(n) {
                    t.c || D(A2(ce, a, i(r, re({
                        cL: n.loaded,
                        bm: n.total
                    }))));
                }), t.addEventListener("progress", function(n) {
                    t.c || D(A2(ce, a, i(r, te({
                        cB: n.loaded,
                        bm: n.lengthComputable ? Ot(n.total) : Tt
                    }))));
                });
            }(a, c, r.bu.a);
            try {
                c.open(r.ch, r.bv, !0);
            } catch (a) {
                return e(Gn(r.bv));
            }
            return function(a, t) {
                for(var r = t.aV; r.b; r = r.b)a.setRequestHeader(r.a.a, r.a.b);
                a.timeout = t.cU.a || 0, a.responseType = t.bW.d, a.withCredentials = t.bA;
            }(c, r), r.bE.a && c.setRequestHeader("Content-Type", r.bE.a), c.send(r.bE.b), function() {
                c.c = !0, c.abort();
            };
        });
    });
    function dt(a) {
        if (!a) return Wn;
        for(var t = Wn, r = a.split("\r\n"), n = r.length; n--;){
            var e = r[n], c = e.indexOf(": ");
            if (c > 0) {
                var i = e.substring(0, c), u = e.substring(c + 2);
                t = A3(pn, i, function(a) {
                    return Ot(ee(a) ? u + ", " + a.a : u);
                }, t);
            }
        }
        return t;
    }
    var ht = F3(function(a, t, r) {
        return {
            $: 0,
            d: a,
            b: t,
            a: r
        };
    }), lt = F2(function(a, t) {
        return {
            $: 0,
            d: t.d,
            b: t.b,
            a: function(r) {
                return a(t.a(r));
            }
        };
    }), mt = F2(function(a, t) {
        return {
            $: 0,
            a: a,
            b: t
        };
    }), pt = F2(function(a, t) {
        var r = "g";
        a.ck && (r += "m"), a.bI && (r += "i");
        try {
            return Ot(RegExp(t, r));
        } catch (a) {
            return Tt;
        }
    }), jt = F2(function(a, t) {
        return null !== t.match(a);
    }), Wt = 1, It = 2, Pt = 0, $t = v, yt = F3(function(a, t, r) {
        for(;;){
            if (-2 === r.$) return t;
            var n = r.d, e = a, c = A3(a, r.b, r.c, A3(yt, a, t, r.e));
            a = e, t = c, r = n;
        }
    }), wt = function(a) {
        return A3(yt, F3(function(a, t, r) {
            return A2($t, i(a, t), r);
        }), f, a);
    }, kt = function(a) {
        return {
            $: 1,
            a: a
        };
    }, At = F2(function(a, t) {
        return {
            $: 3,
            a: a,
            b: t
        };
    }), xt = F2(function(a, t) {
        return {
            $: 0,
            a: a,
            b: t
        };
    }), Lt = F2(function(a, t) {
        return {
            $: 1,
            a: a,
            b: t
        };
    }), Et = function(a) {
        return {
            $: 0,
            a: a
        };
    }, Mt = function(a) {
        return {
            $: 2,
            a: a
        };
    }, Nt = p, Ot = function(a) {
        return {
            $: 0,
            a: a
        };
    }, Tt = {
        $: 1
    }, Ct = J, _t = x, Rt = F2(function(a, t) {
        return s(A2($, a, t));
    }), Ht = F3(function(a, t, r) {
        for(;;){
            if (!r.b) return t;
            var n = r.b, e = a, c = A2(a, r.a, t);
            a = e, t = c, r = n;
        }
    }), zt = function(a) {
        return A3(Ht, F2(function(a, t) {
            return t + 1;
        }), 0, a);
    }, Ft = g, St = F3(function(a, t, r) {
        for(;;){
            if (e(a, t) >= 1) return r;
            var n = a, c = t - 1, i = A2($t, t, r);
            a = n, t = c, r = i;
        }
    }), qt = F2(function(a, t) {
        return A3(St, a, t, f);
    }), Jt = F2(function(a, t) {
        return A3(Ft, a, A2(qt, 0, zt(t) - 1), t);
    }), Xt = function(a) {
        return A3(Ht, $t, f, a);
    }, Yt = function(a) {
        var t = a.charCodeAt(0);
        return isNaN(t) ? Tt : Ot(55296 > t || t > 56319 ? i(a[0], a.slice(1)) : i(a[0] + a[1], a.slice(2)));
    }, Zt = 32, Bt = F4(function(a, t, r, n) {
        return {
            $: 0,
            a: a,
            b: t,
            c: r,
            d: n
        };
    }), Vt = [], Ut = j, Kt = F2(function(a, t) {
        return P(t) / P(a);
    }), Dt = Ut(A2(Kt, 2, Zt)), Gt = A4(Bt, 0, Dt, Vt, Vt), Qt = h, ar = function(a) {
        return {
            $: 1,
            a: a
        };
    }, tr = W, rr = function(a) {
        return a.length;
    }, nr = F2(function(a, t) {
        return e(a, t) > 0 ? a : t;
    }), er = function(a) {
        return {
            $: 0,
            a: a
        };
    }, cr = l, ir = F2(function(a, t) {
        for(;;){
            var r = A2(cr, Zt, a), n = r.b, e = A2($t, er(r.a), t);
            if (!n.b) return Xt(e);
            a = n, t = e;
        }
    }), ur = F2(function(a, t) {
        for(;;){
            var r = Ut(t / Zt);
            if (1 === r) return A2(cr, Zt, a).a;
            a = A2(ir, a, f), t = r;
        }
    }), or = F2(function(a, t) {
        if (t.f) {
            var r = t.f * Zt, n = tr(A2(Kt, Zt, r - 1)), e = a ? Xt(t.j) : t.j, c = A2(ur, e, t.f);
            return A4(Bt, rr(t.i) + r, A2(nr, 5, n * Dt), c, t.i);
        }
        return A4(Bt, rr(t.i), Dt, Vt, t.i);
    }), fr = F5(function(a, t, r, n, e) {
        for(;;){
            if (0 > t) return A2(or, !1, {
                j: n,
                f: r / Zt | 0,
                i: e
            });
            var c = ar(A3(Qt, Zt, t, a));
            t -= Zt, n = A2($t, c, n);
        }
    }), br = F2(function(a, t) {
        if (a > 0) {
            var r = a % Zt;
            return A5(fr, t, a - r - Zt, a, f, A3(Qt, r, a - r, t));
        }
        return Gt;
    }), vr = function(a) {
        return !a.$;
    }, sr = T, gr = function(a) {
        return {
            $: 0,
            a: a
        };
    }, dr = function(a) {
        switch(a.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, hr = function(a) {
        return a;
    }, lr = hr, mr = F6(function(a, t, r, n, e, c) {
        return {
            b0: c,
            aX: t,
            a8: n,
            ba: r,
            be: a,
            bf: e
        };
    }), pr = w, jr = y, Wr = F2(function(a, t) {
        return 1 > a ? t : A3(jr, a, t.length, t);
    }), Ir = A, Pr = function(a) {
        return "" === a;
    }, $r = F2(function(a, t) {
        return 1 > a ? "" : A3(jr, 0, a, t);
    }), yr = F5(function(a, t, r, n, e) {
        if (Pr(e) || A2(pr, "@", e)) return Tt;
        var c = A2(Ir, ":", e);
        if (c.b) {
            if (c.b.b) return Tt;
            var i = c.a, u = function(a) {
                for(var t = 0, r = a.charCodeAt(0), n = 43 == r || 45 == r ? 1 : 0, e = n; a.length > e; ++e){
                    var c = a.charCodeAt(e);
                    if (48 > c || c > 57) return Tt;
                    t = 10 * t + c - 48;
                }
                return e == n ? Tt : Ot(45 == r ? -t : t);
            }(A2(Wr, i + 1, e));
            if (1 === u.$) return Tt;
            var o = u;
            return Ot(A6(mr, a, A2($r, i, e), o, t, r, n));
        }
        return Ot(A6(mr, a, e, Tt, t, r, n));
    }), wr = F4(function(a, t, r, n) {
        if (Pr(n)) return Tt;
        var e = A2(Ir, "/", n);
        if (e.b) {
            var c = e.a;
            return A5(yr, a, A2(Wr, c, n), t, r, A2($r, c, n));
        }
        return A5(yr, a, "/", t, r, n);
    }), kr = F3(function(a, t, r) {
        if (Pr(r)) return Tt;
        var n = A2(Ir, "?", r);
        if (n.b) {
            var e = n.a;
            return A4(wr, a, Ot(A2(Wr, e + 1, r)), t, A2($r, e, r));
        }
        return A4(wr, a, Tt, t, r);
    }), Ar = F2(function(a, t) {
        if (Pr(t)) return Tt;
        var r = A2(Ir, "#", t);
        if (r.b) {
            var n = r.a;
            return A3(kr, a, Ot(A2(Wr, n + 1, t)), A2($r, n, t));
        }
        return A3(kr, a, Tt, t);
    }), xr = k, Lr = function(a) {
        return A2(xr, "http://", a) ? A2(Ar, 0, A2(Wr, 7, a)) : A2(xr, "https://", a) ? A2(Ar, 1, A2(Wr, 8, a)) : Tt;
    }, Er = function() {
        for(;;);
    }, Mr = Z, Nr = Mr(0), Or = F4(function(a, t, r, n) {
        if (n.b) {
            var e = n.a, c = n.b;
            if (c.b) {
                var i = c.a, u = c.b;
                if (u.b) {
                    var o = u.a, f = u.b;
                    if (f.b) {
                        var b = f.b;
                        return A2(a, e, A2(a, i, A2(a, o, A2(a, f.a, r > 500 ? A3(Ht, a, t, Xt(b)) : A4(Or, a, t, r + 1, b)))));
                    }
                    return A2(a, e, A2(a, i, A2(a, o, t)));
                }
                return A2(a, e, A2(a, i, t));
            }
            return A2(a, e, t);
        }
        return t;
    }), Tr = F3(function(a, t, r) {
        return A4(Or, a, t, 0, r);
    }), Cr = F2(function(a, t) {
        return A3(Tr, F2(function(t, r) {
            return A2($t, a(t), r);
        }), f, t);
    }), _r = V, Rr = F2(function(a, t) {
        return A2(_r, function(t) {
            return Mr(a(t));
        }, t);
    }), Hr = F3(function(a, t, r) {
        return A2(_r, function(t) {
            return A2(_r, function(r) {
                return Mr(A2(a, t, r));
            }, r);
        }, t);
    }), zr = function(a) {
        return A3(Tr, Hr($t), Mr(f), a);
    }, Fr = oa, Sr = F2(function(a, t) {
        var r = t;
        return G(A2(_r, Fr(a), r));
    });
    ca.Task = ia(Nr, F3(function(a, t) {
        return A2(Rr, function() {
            return 0;
        }, zr(A2(Cr, Sr(a), t)));
    }), F3(function() {
        return Mr(0);
    }), F2(function(a, t) {
        return A2(Rr, a, t);
    }));
    var qr, Jr, Xr, Yr = ba("Task"), Zr = F2(function(a, t) {
        return Yr(A2(Rr, a, t));
    }), Br = function(a) {
        return {
            $: 17,
            a: a
        };
    }, Vr = {
        bT: "",
        b$: "",
        b9: "",
        cg: ""
    }, Ur = {
        bL: 0,
        cA: 0
    }, Kr = {
        cI: {
            aW: 0,
            c0: 0
        },
        c$: {
            aW: 0,
            c0: 0,
            c3: 0,
            c4: 0
        }
    }, Dr = bt(function() {
        return {
            cI: vt(),
            c$: {
                c3: ot.pageXOffset,
                c4: ot.pageYOffset,
                c0: ut.documentElement.clientWidth,
                aW: ut.documentElement.clientHeight
            }
        };
    }), Gr = s([
        {
            aI: .6425,
            bP: {
                aW: 500,
                c0: 321.25
            },
            av: 1,
            cc: -1,
            cd: !1,
            bv: "/images/Kazu.jpeg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 33,
            cc: -1,
            cd: !1,
            bv: "/images/kazu-studio-lights.jpg"
        },
        {
            aI: .6675,
            bP: {
                aW: 500,
                c0: 333.75
            },
            av: 2,
            cc: -1,
            cd: !1,
            bv: "/images/Kazu-toddler.jpg"
        },
        {
            aI: 1.37634409,
            bP: {
                aW: 744,
                c0: 1024
            },
            av: 30,
            cc: -1,
            cd: !1,
            bv: "/images/baby.jpg"
        },
        {
            aI: 1,
            bP: {
                aW: 1024,
                c0: 1024
            },
            av: 32,
            cc: -1,
            cd: !1,
            bv: "/images/kazu-lion.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 31,
            cc: -1,
            cd: !1,
            bv: "/images/toddler-playing.jpg"
        },
        {
            aI: .6676,
            bP: {
                aW: 500,
                c0: 333.8
            },
            av: 4,
            cc: -1,
            cd: !1,
            bv: "/images/Jack.jpeg"
        },
        {
            aI: 1.4979,
            bP: {
                aW: 500,
                c0: 748.95
            },
            av: 3,
            cc: -1,
            cd: !1,
            bv: "/images/Daniel.jpeg"
        },
        {
            aI: 1.49722,
            bP: {
                aW: 500,
                c0: 748.61
            },
            av: 6,
            cc: -1,
            cd: !1,
            bv: "/images/Kazu-Jack2.jpeg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 34,
            cc: -1,
            cd: !1,
            bv: "/images/christmas-girl.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 35,
            cc: -1,
            cd: !1,
            bv: "/images/christmas-girl-2.jpg"
        },
        {
            aI: 1.52005944,
            bP: {
                aW: 673,
                c0: 1023
            },
            av: 38,
            cc: -1,
            cd: !1,
            bv: "/images/joanna.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 39,
            cc: -1,
            cd: !1,
            bv: "/images/keith-studio.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 40,
            cc: -1,
            cd: !1,
            bv: "/images/michael-miller-studio.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 41,
            cc: -1,
            cd: !1,
            bv: "/images/ron-anderson.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 42,
            cc: -1,
            cd: !1,
            bv: "/images/prashant-chetana.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 28,
            cc: -1,
            cd: !1,
            bv: "/images/rhonda.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 36,
            cc: -1,
            cd: !1,
            bv: "/images/grace.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 37,
            cc: -1,
            cd: !1,
            bv: "/images/grace-2.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 43,
            cc: -1,
            cd: !1,
            bv: "/images/felicia-yoga-2.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 44,
            cc: -1,
            cd: !1,
            bv: "/images/felicia-yoga-3.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 45,
            cc: -1,
            cd: !1,
            bv: "/images/felicia-yoga-4.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 46,
            cc: -1,
            cd: !1,
            bv: "/images/joy.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 49,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-1.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 48,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-2.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 50,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-3.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 52,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-5.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 53,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-6.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 54,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-7.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 55,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-9.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 51,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-4.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 56,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-8.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 57,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-10.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 58,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-11.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 59,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-12.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 60,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-13.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 61,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-14.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 62,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-15.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 63,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-16.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 64,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-17.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 65,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-18.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 66,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-19.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 67,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-20.jpg"
        },
        {
            aI: 1.50367107,
            bP: {
                aW: 681,
                c0: 1024
            },
            av: 68,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-21.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 69,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-22.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 70,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-23.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 71,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-24.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 72,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-25.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 73,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-26.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 74,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-27.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 75,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-28.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 76,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-29.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 77,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-30.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 78,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-31.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 79,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-32.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 80,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-33.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 81,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-34.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 82,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-35.jpg"
        },
        {
            aI: 1.50367107,
            bP: {
                aW: 681,
                c0: 1024
            },
            av: 83,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-36.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 84,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-37.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 85,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-38.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 86,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-39.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 87,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-40.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 88,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-41.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 89,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-42.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 90,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-43.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 91,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-44.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 92,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-45.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 93,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-46.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 94,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-47.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 96,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-49.jpg"
        },
        {
            aI: 1.50367107,
            bP: {
                aW: 681,
                c0: 1024
            },
            av: 97,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-50.jpg"
        },
        {
            aI: 1.50367107,
            bP: {
                aW: 681,
                c0: 1024
            },
            av: 98,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-51.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 99,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-52.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 100,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-53.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 101,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-54.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 102,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-55.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 103,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-56.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 104,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-57.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 105,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-58.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 106,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-59.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 107,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-60.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 108,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-61.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 109,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-62.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 110,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-63.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 110,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-64.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 111,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-65.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 112,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-66.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 113,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-67.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 114,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-68.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 115,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-69.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 116,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-70.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 117,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-71.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 118,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-72.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 119,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-73.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 120,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-74.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 121,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-75.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 122,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-76.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 123,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-77.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 124,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-78.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 125,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-79.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 126,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-80.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 127,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-81.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 128,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-82.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 129,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-83.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 130,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-84.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 131,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-85.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 132,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-86.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 133,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-87.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 134,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-88.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 135,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-89.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 136,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-90.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 137,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-91.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 138,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-92.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 139,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-93.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 140,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-94.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 141,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-95.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 142,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-96.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 143,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-97.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 144,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-98.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 145,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-99.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 146,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-100.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 147,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-101.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 148,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-102.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 149,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-103.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 150,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-104.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 151,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-105.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 152,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-106.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 153,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-107.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 154,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-108.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 155,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-109.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 156,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-110.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 157,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-111.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 158,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-112.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 159,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-113.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 160,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-114.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 161,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-115.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 162,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-116.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 163,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-117.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 164,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-118.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 165,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-119.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 166,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-120.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 167,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-122.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 168,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-121.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 169,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-123.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 170,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-124.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 171,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-126.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 172,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-127.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 173,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-125.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 174,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-128.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 175,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-129.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 176,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-130.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 177,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-131.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 178,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-132.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 179,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-133.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 180,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-134.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 181,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-135.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 182,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-136.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 183,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-137.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 184,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-138.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 185,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-139.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 186,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-140.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 187,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-141.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 188,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-142.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 189,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-143.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 190,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-144.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 191,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-145.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 192,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-146.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 193,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-147.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 194,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-148.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 195,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-149.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 196,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-150.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 197,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-151.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 198,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-152.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 199,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-153.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 200,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-155.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 201,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-154.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 202,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-156.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 203,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-157.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 204,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-158.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 205,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-159.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 206,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-161.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 207,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-160.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 208,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-162.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 209,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-163.jpg"
        },
        {
            aI: .66764418,
            bP: {
                aW: 1023,
                c0: 683
            },
            av: 210,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-164.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 211,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-165.jpg"
        },
        {
            aI: 1.49780381,
            bP: {
                aW: 683,
                c0: 1023
            },
            av: 212,
            cc: -1,
            cd: !1,
            bv: "/images/theatre-166.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 213,
            cc: -1,
            cd: !1,
            bv: "/images/festival-2.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 215,
            cc: -1,
            cd: !1,
            bv: "/images/festival-4.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 216,
            cc: -1,
            cd: !1,
            bv: "/images/festival-3.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 218,
            cc: -1,
            cd: !1,
            bv: "/images/festival-6.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 220,
            cc: -1,
            cd: !1,
            bv: "/images/festival-8.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 219,
            cc: -1,
            cd: !1,
            bv: "/images/festival-7.jpg"
        },
        {
            aI: 1.50146628,
            bP: {
                aW: 682,
                c0: 1024
            },
            av: 222,
            cc: -1,
            cd: !1,
            bv: "/images/festival-10.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 224,
            cc: -1,
            cd: !1,
            bv: "/images/festival-12.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 225,
            cc: -1,
            cd: !1,
            bv: "/images/festival-13.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 221,
            cc: -1,
            cd: !1,
            bv: "/images/festival-9.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 223,
            cc: -1,
            cd: !1,
            bv: "/images/festival-11.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 214,
            cc: -1,
            cd: !1,
            bv: "/images/festival-1.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 226,
            cc: -1,
            cd: !1,
            bv: "/images/festival-14.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 227,
            cc: -1,
            cd: !1,
            bv: "/images/festival-15.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 228,
            cc: -1,
            cd: !1,
            bv: "/images/festival-16.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 229,
            cc: -1,
            cd: !1,
            bv: "/images/festival-17.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 230,
            cc: -1,
            cd: !1,
            bv: "/images/festival-18.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 231,
            cc: -1,
            cd: !1,
            bv: "/images/festival-19.jpg"
        },
        {
            aI: 1.77777778,
            bP: {
                aW: 576,
                c0: 1024
            },
            av: 232,
            cc: -1,
            cd: !1,
            bv: "/images/festival-20.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 233,
            cc: -1,
            cd: !1,
            bv: "/images/festival-21.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 16,
            cc: -1,
            cd: !1,
            bv: "/images/third-coast-trio-bass.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 23,
            cc: -1,
            cd: !1,
            bv: "/images/matt-alber-color.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 24,
            cc: -1,
            cd: !1,
            bv: "/images/drummer.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 25,
            cc: -1,
            cd: !1,
            bv: "/images/lady-singer.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 26,
            cc: -1,
            cd: !1,
            bv: "/images/male-singer.jpg"
        },
        {
            aI: .66601562,
            bP: {
                aW: 1024,
                c0: 682
            },
            av: 18,
            cc: -1,
            cd: !1,
            bv: "/images/jodi-adair-solo.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 12,
            cc: -1,
            cd: !1,
            bv: "/images/landshark-guitarist.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 13,
            cc: -1,
            cd: !1,
            bv: "/images/instruments.jpg"
        },
        {
            aI: .65298143,
            bP: {
                aW: 1023,
                c0: 668
            },
            av: 14,
            cc: -1,
            cd: !1,
            bv: "/images/astronaut-suit.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 15,
            cc: -1,
            cd: !1,
            bv: "/images/pianist.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 17,
            cc: -1,
            cd: !1,
            bv: "/images/jodi-adair.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 19,
            cc: -1,
            cd: !1,
            bv: "/images/daniel-glass.jpg"
        },
        {
            aI: .66568915,
            bP: {
                aW: 1023,
                c0: 681
            },
            av: 20,
            cc: -1,
            cd: !1,
            bv: "/images/michael-bahan.jpg"
        },
        {
            aI: 1.50220264,
            bP: {
                aW: 681,
                c0: 1023
            },
            av: 21,
            cc: -1,
            cd: !1,
            bv: "/images/michael-bahan-2.jpg"
        },
        {
            aI: .80273438,
            bP: {
                aW: 1024,
                c0: 822
            },
            av: 11,
            cc: -1,
            cd: !1,
            bv: "/images/landshark.jpg"
        },
        {
            aI: 1.80918728,
            bP: {
                aW: 566,
                c0: 1024
            },
            av: 10,
            cc: -1,
            cd: !1,
            bv: "/images/continental-graffiti-2.jpg"
        },
        {
            aI: .63538612,
            bP: {
                aW: 1023,
                c0: 650
            },
            av: 9,
            cc: -1,
            cd: !1,
            bv: "/images/continental-graffiti.jpg"
        }
    ]), Qr = F5(function(a, t, r, n, e) {
        return {
            J: n,
            O: r,
            F: t,
            R: e,
            S: a
        };
    }), an = function(a) {
        return a.b && ("" !== a.a || a.b.b) ? A2($t, a.a, an(a.b)) : f;
    }, tn = F2(function(a, t) {
        return Ot(1 === t.$ ? s([
            a
        ]) : A2($t, a, t.a));
    }), rn = function(a) {
        try {
            return Ot(decodeURIComponent(a));
        } catch (a) {
            return Tt;
        }
    }, nn = c, en = F2(function(a, t) {
        a: for(;;){
            if (-2 === t.$) return Tt;
            var r = t.c, n = t.d, e = t.e;
            switch(A2(nn, a, t.b)){
                case 0:
                    t = n;
                    continue a;
                case 1:
                    return Ot(r);
                default:
                    t = e;
                    continue a;
            }
        }
    }), cn = F5(function(a, t, r, n, e) {
        return {
            $: -1,
            a: a,
            b: t,
            c: r,
            d: n,
            e: e
        };
    }), un = {
        $: -2
    }, on = F5(function(a, t, r, n, e) {
        if (-1 !== e.$ || e.a) {
            if (-1 !== n.$ || n.a || -1 !== n.d.$ || n.d.a) return A5(cn, a, t, r, n, e);
            var c = n.d;
            return i = n.e, A5(cn, 0, n.b, n.c, A5(cn, 1, c.b, c.c, c.d, c.e), A5(cn, 1, t, r, i, e));
        }
        var i, u = e.b, o = e.c, f = e.d, b = e.e;
        return -1 !== n.$ || n.a ? A5(cn, a, u, o, A5(cn, 0, t, r, n, f), b) : A5(cn, 0, t, r, A5(cn, 1, n.b, n.c, n.d, i = n.e), A5(cn, 1, u, o, f, b));
    }), fn = F3(function(a, t, r) {
        if (-2 === r.$) return A5(cn, 0, a, t, un, un);
        var n = r.a, e = r.b, c = r.c, i = r.d, u = r.e;
        switch(A2(nn, a, e)){
            case 0:
                return A5(on, n, e, c, A3(fn, a, t, i), u);
            case 1:
                return A5(cn, n, e, t, i, u);
            default:
                return A5(on, n, e, c, i, A3(fn, a, t, u));
        }
    }), bn = F3(function(a, t, r) {
        var n = A3(fn, a, t, r);
        return -1 !== n.$ || n.a ? n : A5(cn, 1, n.b, n.c, n.d, n.e);
    }), vn = function(a) {
        if (-1 === a.$ && -1 === a.d.$ && -1 === a.e.$) {
            if (-1 !== a.e.d.$ || a.e.d.a) {
                var t = a.d, r = a.e;
                return i = r.b, u = r.c, n = r.d, b = r.e, A5(cn, 1, a.b, a.c, A5(cn, 0, t.b, t.c, t.d, t.e), A5(cn, 0, i, u, n, b));
            }
            var n, e = a.d, c = a.e, i = c.b, u = c.c, o = (n = c.d).d, f = n.e, b = c.e;
            return A5(cn, 0, n.b, n.c, A5(cn, 1, a.b, a.c, A5(cn, 0, e.b, e.c, e.d, e.e), o), A5(cn, 1, i, u, f, b));
        }
        return a;
    }, sn = function(a) {
        if (-1 === a.$ && -1 === a.d.$ && -1 === a.e.$) {
            if (-1 !== a.d.d.$ || a.d.d.a) {
                var t = a.d, r = a.e;
                return f = r.b, b = r.c, v = r.d, s = r.e, A5(cn, 1, n = a.b, e = a.c, A5(cn, 0, t.b, t.c, t.d, u = t.e), A5(cn, 0, f, b, v, s));
            }
            var n = a.b, e = a.c, c = a.d, i = c.d, u = c.e, o = a.e, f = o.b, b = o.c, v = o.d, s = o.e;
            return A5(cn, 0, c.b, c.c, A5(cn, 1, i.b, i.c, i.d, i.e), A5(cn, 1, n, e, u, A5(cn, 0, f, b, v, s)));
        }
        return a;
    }, gn = F7(function(a, t, r, n, e, c, i) {
        if (-1 !== c.$ || c.a) {
            a: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return sn(t);
                        break a;
                    }
                    return sn(t);
                }
                break a;
            }
            return t;
        }
        return A5(cn, r, c.b, c.c, c.d, A5(cn, 0, n, e, c.e, i));
    }), dn = function(a) {
        if (-1 === a.$ && -1 === a.d.$) {
            var t = a.a, r = a.b, n = a.c, e = a.d, c = e.d, i = a.e;
            if (1 === e.a) {
                if (-1 !== c.$ || c.a) {
                    var u = vn(a);
                    if (-1 === u.$) {
                        var o = u.e;
                        return A5(on, u.a, u.b, u.c, dn(u.d), o);
                    }
                    return un;
                }
                return A5(cn, t, r, n, dn(e), i);
            }
            return A5(cn, t, r, n, dn(e), i);
        }
        return un;
    }, hn = F2(function(a, t) {
        if (-2 === t.$) return un;
        var r = t.a, n = t.b, c = t.c, i = t.d, u = t.e;
        if (0 > e(a, n)) {
            if (-1 === i.$ && 1 === i.a) {
                var o = i.d;
                if (-1 !== o.$ || o.a) {
                    var f = vn(t);
                    if (-1 === f.$) {
                        var b = f.e;
                        return A5(on, f.a, f.b, f.c, A2(hn, a, f.d), b);
                    }
                    return un;
                }
                return A5(cn, r, n, c, A2(hn, a, i), u);
            }
            return A5(cn, r, n, c, A2(hn, a, i), u);
        }
        return A2(ln, a, A7(gn, a, t, r, n, c, i, u));
    }), ln = F2(function(a, t) {
        if (-1 === t.$) {
            var n = t.a, e = t.b, c = t.c, i = t.d, u = t.e;
            if (r(a, e)) {
                var o = function(a) {
                    for(;;){
                        if (-1 !== a.$ || -1 !== a.d.$) return a;
                        a = a.d;
                    }
                }(u);
                return -1 === o.$ ? A5(on, n, o.b, o.c, i, dn(u)) : un;
            }
            return A5(on, n, e, c, i, A2(hn, a, u));
        }
        return un;
    }), mn = F2(function(a, t) {
        var r = A2(hn, a, t);
        return -1 !== r.$ || r.a ? r : A5(cn, 1, r.b, r.c, r.d, r.e);
    }), pn = F3(function(a, t, r) {
        var n = t(A2(en, a, r));
        return n.$ ? A2(mn, a, r) : A3(bn, a, n.a, r);
    }), jn = F2(function(a, t) {
        var r = A2(Rt, "=", a);
        if (r.b && r.b.b && !r.b.b.b) {
            var n = r.b.a, e = rn(r.a);
            if (1 === e.$) return t;
            var c = e.a, i = rn(n);
            return 1 === i.$ ? t : A3(pn, c, tn(i.a), t);
        }
        return t;
    }), Wn = un, In = F2(function(a, t) {
        var r;
        return function(a) {
            a: for(;;){
                if (a.b) {
                    var t = a.a, r = t.F;
                    if (r.b) {
                        if ("" !== r.a || r.b.b) {
                            a = a.b;
                            continue a;
                        }
                        return Ot(t.R);
                    }
                    return Ot(t.R);
                }
                return Tt;
            }
        }(a(A5(Qr, f, function(a) {
            var t = A2(Rt, "/", a);
            return an(t.b && "" === t.a ? t.b : t);
        }(t.a8), 1 === (r = t.bf).$ ? Wn : A3(Tr, jn, Wn, A2(Rt, "&", r.a)), t.b0, hr)));
    }), Pn = F2(function(a, t) {
        return A5(Qr, t.S, t.F, t.O, t.J, a(t.R));
    }), $n = F2(function(a, t) {
        var r = t;
        return function(t) {
            var n = t.S, e = t.F, c = t.O, i = t.J;
            return A2(Cr, Pn(t.R), r(A5(Qr, n, e, c, i, a)));
        };
    }), yn = F2(function(a, t) {
        return t.b ? A3(Tr, $t, t, a) : a;
    }), wn = F2(function(a, t) {
        return A3(Tr, yn, f, A2(Cr, a, t));
    }), kn = F2(function(a, t) {
        return A3(Tr, F2(function(t, r) {
            return a(t) ? A2($t, t, r) : r;
        }), f, t);
    }), An = function(a) {
        return a.b ? Ot(a.a) : Tt;
    }, xn = F2(function(a, t) {
        return r(t.a, a);
    }), Ln = s([
        i(0, "work"),
        i(1, "about"),
        i(2, "contact")
    ]), En = function(a) {
        var t = An(A2(kn, xn(a), Ln));
        return t.$ ? "" : t.a.b;
    }, Mn = function(a) {
        return function(t) {
            var n = t.S, e = t.F, c = t.O, i = t.J, u = t.R;
            if (e.b) {
                var o = e.a, b = e.b;
                return r(o, a) ? s([
                    A5(Qr, A2($t, o, n), b, c, i, u)
                ]) : f;
            }
            return f;
        };
    }, Nn = function(a) {
        return s([
            a
        ]);
    }, On = (qr = s([
        A2($n, 0, Nn),
        A2($n, 0, Mn(En(0))),
        A2($n, 1, Mn(En(1))),
        A2($n, 2, Mn(En(2)))
    ]), function(a) {
        return A2(wn, function(t) {
            return t(a);
        }, qr);
    }), Tn = F3(function(a, t, r) {
        return i({
            aj: Vr,
            as: 0,
            bM: A2(In, On, t),
            bO: Ur,
            bU: Tt,
            ab: {
                b1: .88,
                aY: 24,
                bs: 500
            },
            b3: !1,
            b4: A2(Jt, F2(function(a, t) {
                return u(t, {
                    cc: a
                });
            }), Gr),
            a1: !1,
            cf: !1,
            cn: r,
            cE: Tt,
            cJ: Tt,
            cM: !1,
            cY: !1,
            cZ: !1,
            ar: f,
            c1: Kr,
            bx: !1
        }, A2(Zr, Br, Dr));
    }), Cn = O, _n = N, Rn = E, Hn = (Jr = "messageReceiver", Xr = A2(Cn, function(a) {
        return A2(Cn, function(t) {
            return gr({
                cI: t,
                c$: a
            });
        }, A2(_n, "scene", A2(Cn, function(a) {
            return A2(Cn, function(t) {
                return gr({
                    aW: t,
                    c0: a
                });
            }, A2(_n, "height", Rn));
        }, A2(_n, "width", Rn))));
    }, A2(_n, "viewport", A2(Cn, function(a) {
        return A2(Cn, function(t) {
            return A2(Cn, function(r) {
                return A2(Cn, function(n) {
                    return gr({
                        aW: n,
                        c0: r,
                        c3: t,
                        c4: a
                    });
                }, A2(_n, "height", Rn));
            }, A2(_n, "width", Rn));
        }, A2(_n, "x", Rn));
    }, A2(_n, "y", Rn)))), function(a) {
        ca[a] && m(3);
    }(Jr), ca[Jr] = {
        f: ma,
        u: Xr,
        a: function(a, t) {
            var r = f, n = ca[a].u, e = Z(null);
            return ca[a].b = e, ca[a].c = F3(function(a, t) {
                return r = t, e;
            }), {
                send: function(a) {
                    var e = A2(C, n, a);
                    vr(e) || m(4);
                    for(var c = e.a, i = r; i.b; i = i.b)t(i.a(c));
                }
            };
        }
    }, ba(Jr)), zn = {
        $: 10
    }, Fn = F2(function(a, t) {
        return t.$ ? Tt : a(t.a);
    }), Sn = function(a) {
        return {
            $: 2,
            m: a
        };
    }, qn = F2(function(a) {
        return a;
    }), Jn = function(a) {
        return B(function(t) {
            var r = setTimeout(function() {
                t(Z(0));
            }, a);
            return function() {
                clearTimeout(r);
            };
        });
    }, Xn = F2(function(a, t) {
        return A2(Zr, hr, A2(_r, qn(Mr(t)), Jn(a)));
    }), Yn = F2(function(a, t) {
        return 0 > e(a, t) ? a : t;
    }), Zn = I, Bn = F2(function(a, t) {
        var r = t.c$;
        switch(i(a.bL, a.cA).a){
            case 0:
            case 1:
                return r.aW;
            default:
                return 500;
        }
    }), Vn = Sn(f), Un = function(a) {
        var t = i(a.bL, a.cA);
        a: for(;;)switch(t.a){
            case 0:
                return .88;
            case 1:
                if (t.b) break a;
                return .88;
            default:
                break a;
        }
        return .94;
    }, Kn = function(a) {
        return {
            $: 12,
            a: a
        };
    }, Dn = F2(function(a, t) {
        return {
            $: 3,
            a: a,
            b: t
        };
    }), Gn = function(a) {
        return {
            $: 0,
            a: a
        };
    }, Qn = F2(function(a, t) {
        return {
            $: 4,
            a: a,
            b: t
        };
    }), ae = {
        $: 2
    }, te = function(a) {
        return {
            $: 1,
            a: a
        };
    }, re = function(a) {
        return {
            $: 0,
            a: a
        };
    }, ne = {
        $: 1
    }, ee = function(a) {
        return !a.$;
    }, ce = fa, ie = function(a) {
        return a;
    }, ue = function(a) {
        var t, r, n = a.b9, e = a.bT, c = a.cg;
        return r = s([
            i("firstName", ie(a.b$)),
            i("lastName", ie(n)),
            i("emailAddress", ie(e)),
            i("message", ie(c))
        ]), t = A3(Ht, F2(function(a, t) {
            return A3(Y, a.a, a.b, t);
        }), {}, r), A2(mt, "application/json", A2(Ct, 0, t));
    }, oe = F3(function(a, t, r) {
        return t(a(r));
    }), fe = F2(function(a, t) {
        return A3(ht, "", hr, A2(oe, t, a));
    }), be = function(a) {
        return {
            $: 4,
            a: a
        };
    }, ve = {
        $: 2
    }, se = {
        $: 1
    }, ge = F2(function(a, t) {
        return t.$ ? kt(a(t.a)) : Et(t.a);
    }), de = F2(function(a, t) {
        switch(t.$){
            case 0:
                return kt({
                    $: 0,
                    a: t.a
                });
            case 1:
                return kt(se);
            case 2:
                return kt(ve);
            case 3:
                return kt({
                    $: 3,
                    a: t.a.cN
                });
            default:
                return A2(ge, be, a(t.b));
        }
    }), he = function(a) {
        return {
            $: 1,
            a: a
        };
    }, le = F2(function(a, t) {
        return {
            bh: a,
            bq: t
        };
    }), me = Mr(A2(le, Wn, f)), pe = function(a) {
        return B(function(t) {
            var r = a.f;
            2 === r.$ && r.c && r.c(), a.f = null, t(Z(0));
        });
    }, je = G, We = F3(function(a, t, r) {
        a: for(;;){
            if (t.b) {
                var n = t.a, e = t.b;
                if (n.$) {
                    var c = n.a;
                    return A2(_r, function(t) {
                        var n = c.bu;
                        return A3(We, a, e, 1 === n.$ ? r : A3(bn, n.a, t, r));
                    }, je(A3(gt, a, Fr(a), c)));
                }
                var i = n.a, u = A2(en, i, r);
                if (1 === u.$) {
                    t = e;
                    continue a;
                }
                return A2(_r, function() {
                    return A3(We, a, e, A2(mn, i, r));
                }, pe(u.a));
            }
            return Mr(r);
        }
    }), Ie = F4(function(a, t, r, n) {
        return A2(_r, function(a) {
            return Mr(A2(le, a, r));
        }, A3(We, a, t, n.bh));
    }), Pe = F3(function(a, t, r) {
        var n = a(t);
        return n.$ ? r : A2($t, n.a, r);
    }), $e = F2(function(a, t) {
        return A3(Tr, Pe(a), f, t);
    }), ye = F4(function(a, t, n, e) {
        var c = e.b;
        return r(t, e.a) ? Ot(A2(Fr, a, c(n))) : Tt;
    }), we = F3(function(a, t, r) {
        return A2(_r, function() {
            return Mr(r);
        }, zr(A2($e, A3(ye, a, t.a, t.b), r.bq)));
    }), ke = F2(function(a, t) {
        if (t.$) {
            var r = t.a;
            return he({
                bA: r.bA,
                bE: r.bE,
                bW: A2(lt, a, r.bW),
                aV: r.aV,
                ch: r.ch,
                cU: r.cU,
                bu: r.bu,
                bv: r.bv
            });
        }
        return {
            $: 0,
            a: t.a
        };
    }), Ae = F2(function(a, t) {
        return {
            $: 0,
            a: a,
            b: t
        };
    });
    ca.Http = ia(me, Ie, we, ke, F2(function(a, t) {
        return A2(Ae, t.a, A2(oe, t.b, a));
    }));
    var xe, Le, Ee, Me, Ne, Oe, Te = ba("Http"), Ce = (ba("Http"), function(a) {
        return function(a) {
            return Te(he({
                bA: !1,
                bE: a.bE,
                bW: a.bW,
                aV: a.aV,
                ch: a.ch,
                cU: a.cU,
                bu: a.bu,
                bv: a.bv
            }));
        }({
            bE: a.bE,
            bW: a.bW,
            aV: f,
            ch: "POST",
            cU: Tt,
            bu: Tt,
            bv: a.bv
        });
    }), _e = ct, Re = {
        $: 18
    }, He = st, ze = A2(Zr, function() {
        return Re;
    }, A2(He, 0, 0)), Fe = function(a) {
        return {
            $: 19,
            a: a
        };
    }, Se = F3(function(a, t, r) {
        return a(t(r));
    }), qe = U, Je = F2(function(a, t) {
        return Yr(A2(qe, A2(Se, A2(Se, Mr, a), kt), A2(_r, A2(Se, A2(Se, Mr, a), Et), t)));
    }), Xe = F2(function(a, t) {
        return 1 === a.$ ? t : t + ":" + _t(a.a);
    }), Ye = F3(function(a, t, r) {
        return 1 === t.$ ? r : o(r, o(a, t.a));
    }), Ze = F3(function(a, t, r) {
        switch(a){
            case 0:
                return u(r, {
                    b$: t
                });
            case 1:
                return u(r, {
                    b9: t
                });
            case 2:
                return u(r, {
                    bT: t
                });
            default:
                return u(r, {
                    cg: t
                });
        }
    }), Be = F2(function(a, t) {
        for(;;){
            if (!a.b) return f;
            var r = a.b, n = (0, a.a)(t);
            if (n.b) return n;
            a = r;
        }
    }), Ve = F2(function(a, t) {
        return function(r) {
            return a(r) ? s([
                t
            ]) : f;
        };
    }), Ue = function(a) {
        return " " === a || "\n" === a || "\t" === a || "\r" === a;
    }, Ke = F2(function(a, t) {
        return A2(Ve, function(t) {
            return function(a) {
                for(;;){
                    var t = Yt(a);
                    if (t.$) return !0;
                    var r = t.a, n = r.b;
                    if (!Ue(r.a)) return !1;
                    a = n;
                }
            }(a(t));
        }, t);
    }), De = jt, Ge = pt, Qe = /.^/, ac = F2(function(a, t) {
        return t.$ ? a : t.a;
    }), tc = A2(ac, Qe, A2(Ge, {
        bI: !0,
        ck: !1
    }, "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$")), rc = F2(function(a, t) {
        return function(r) {
            var n = a(r);
            return function(a) {
                return A2(De, tc, a);
            }(n) ? f : s([
                t(n)
            ]);
        };
    }), nc = function(a) {
        return function(t) {
            return A3(Ht, F2(function(a, r) {
                return o(r, a(t));
            }), f, a);
        };
    }(s([
        A2(Ke, function(a) {
            return a.b$;
        }, i(0, "First name is required.")),
        A2(Ke, function(a) {
            return a.b9;
        }, i(1, "Last name is required.")),
        (xe = s([
            A2(Ke, function(a) {
                return a.bT;
            }, i(2, "Email is required.")),
            A2(rc, function(a) {
                return a.bT;
            }, function(a) {
                return i(2, '"' + a + '" is not a valid email address.');
            })
        ]), function(a) {
            return A2(Be, xe, a);
        }),
        A2(Ke, function(a) {
            return a.cg;
        }, i(3, "Message is required."))
    ])), ec = F2(function(a, t) {
        var r = a(t);
        return r.b ? kt(r) : Et(t);
    }), cc = ec(nc), ic = F2(function(a, t) {
        var n, c, b = t.aj, v = t.ab;
        switch(a.$){
            case 2:
                return i(u(t, {
                    cf: !t.cf
                }), Vn);
            case 0:
                return i(u(t, {
                    bM: Ot(0),
                    cf: !1,
                    cZ: !1
                }), Sn(s([
                    ze,
                    A2(_e, t.cn, "/")
                ])));
            case 3:
                return i(u(t, {
                    bM: Ot(1),
                    cf: !1,
                    cZ: !1
                }), Sn(s([
                    ze,
                    A2(_e, t.cn, En(1))
                ])));
            case 4:
                return i(u(t, {
                    bM: Ot(2),
                    cf: !1,
                    cZ: !1,
                    ar: f
                }), Sn(s([
                    ze,
                    A2(_e, t.cn, En(2))
                ])));
            case 9:
                var g = cc(t.aj);
                if (g.$) return i(u(t, {
                    ar: g.a
                }), Vn);
                var d = g.a;
                return i(u(t, {
                    as: 1,
                    ar: f
                }), function(a) {
                    var t;
                    return Ce({
                        bE: ue(a),
                        bW: (t = Kn, A2(fe, t, de(Et))),
                        bv: "https://n8n.ortynski.org/webhook/photography-contact-form"
                    });
                }(d));
            case 10:
                return i(u(t, {
                    as: 0
                }), Vn);
            case 11:
                var h = A3(Ze, a.a, a.b, b), l = i(zt(t.ar) > 0, cc(h));
                return i(u(t, l.a ? l.b.$ ? {
                    aj: h,
                    ar: l.b.a
                } : {
                    aj: h,
                    ar: f
                } : {
                    aj: h
                }), Vn);
            case 12:
                var m = a.a;
                return m.$ ? i(u(t, {
                    as: 3,
                    bU: Ot(m.a),
                    cE: Tt
                }), Vn) : i(u(t, {
                    as: 2,
                    bU: Tt,
                    cE: Ot(m.a)
                }), A2(Xn, 3e3, zn));
            case 5:
                return i(u(t, {
                    a1: !0,
                    cJ: Ot(a.a)
                }), Vn);
            case 7:
                return i(u(t, {
                    cJ: r(t.cJ, Ot(0)) ? Ot(zt(t.b4) - 1) : A2(Fn, function(a) {
                        return Ot(a - 1);
                    }, t.cJ)
                }), Vn);
            case 8:
                return i(u(t, {
                    cJ: A2(Fn, function(a) {
                        return e(a, zt(t.b4) - 1) > -1 ? Ot(0) : Ot(a + 1);
                    }, t.cJ)
                }), Vn);
            case 6:
                return i(u(t, {
                    a1: !1,
                    cJ: Tt
                }), Vn);
            case 13:
                var p = a.a;
                return i(u(t, {
                    b4: A2(Cr, function(a) {
                        return r(a.av, p.av) ? u(a, {
                            cd: !0
                        }) : a;
                    }, t.b4)
                }), Vn);
            case 14:
                return i(t, (n = t.c1, A2(Zr, Br, A2(qe, function() {
                    return Mr(n);
                }, ft("contentContainer", function(a) {
                    return {
                        cI: {
                            c0: a.scrollWidth,
                            aW: a.scrollHeight
                        },
                        c$: {
                            c3: a.scrollLeft,
                            c4: a.scrollTop,
                            c0: a.clientWidth,
                            aW: a.clientHeight
                        }
                    };
                })))));
            case 17:
                var j = a.a, W = !j.c$.c4 && t.c1.c$.c4 > 0, I = j.c$.c4 > 30 && 30 >= t.c1.c$.c4, P = function(a) {
                    var t, r;
                    return {
                        bL: (t = A2(Yn, a.c0, a.aW), r = A2(nr, a.c0, a.aW), 600 > t ? 0 : r > 1200 ? r > 1200 && 1920 >= r ? 2 : 3 : 1),
                        cA: 0 > e(a.c0, a.aW) ? 0 : 1
                    };
                }({
                    aW: Zn((c = j.c$).aW),
                    c0: Zn(c.c0)
                }), $ = I || j.c$.c4 > 30 && t.c1.c$.c4 >= 30;
                return i(u(t, {
                    bO: P,
                    ab: u(v, {
                        b1: Un(P),
                        bs: A2(Bn, P, j)
                    }),
                    b3: $,
                    cY: I,
                    cZ: W,
                    c1: j,
                    bx: !$ && t.bx
                }), Vn);
            case 15:
                var y = (k = a.a).b0;
                if (y.$) return i(u(t, {
                    bM: A2(In, On, k)
                }), Vn);
                var w = y.a;
                return i(u(t, {
                    bx: !1
                }), A2(Je, Fe, A2(_r, function(a) {
                    return A2(He, 0, a.bS.c4);
                }, function(a) {
                    return ft(a, function(a) {
                        var t = a.getBoundingClientRect(), r = ot.pageXOffset, n = ot.pageYOffset;
                        return {
                            cI: vt(),
                            c$: {
                                c3: r,
                                c4: n,
                                c0: ut.documentElement.clientWidth,
                                aW: ut.documentElement.clientHeight
                            },
                            bS: {
                                c3: r + t.left,
                                c4: n + t.top,
                                c0: t.width,
                                aW: t.height
                            }
                        };
                    });
                }(w))));
            case 16:
                var k, A = a.a;
                return i(t, A.$ ? function(a) {
                    return A2(Zr, Er, B(function() {
                        try {
                            ot.location = a;
                        } catch (a) {
                            pa.location.reload(!1);
                        }
                    }));
                }(k = A.a) : A2(_e, t.cn, function(a) {
                    return A3(Ye, "#", a.b0, A3(Ye, "?", a.bf, o(A2(Xe, a.ba, o(a.be ? "https://" : "http://", a.aX)), a.a8)));
                }(k = A.a)));
            case 1:
                return i(u(t, {
                    bx: !t.bx
                }), Vn);
            default:
                return i(t, Vn);
        }
    }), uc = F2(function(a, t) {
        return A2(Aa, a, ie(t));
    }), oc = uc("className"), fc = $a("a"), bc = "Aleksander Orty\u0144ski", vc = bc + " is a software developer and photographer based in Austin TX.\n        He has been capturing the thrill and emotion of theatrical \n        performances, the inspiring atmosphere of festivals, and\n        stunning studio portraits for over 15 years.\n    ", sc = $a("div"), gc = $a("h3"), dc = function(a) {
        var t;
        return A2(uc, "href", /^javascript:/i.test((t = a).replace(/\s/g, "")) ? "" : t);
    }, hc = $a("p"), lc = uc("target"), mc = Wa, pc = function(a) {
        return A2(sc, function(a) {
            return s(a ? [
                oc("description-container")
            ] : [
                oc("description-container"),
                oc("single-column")
            ]);
        }(a), s([
            A2(gc, f, s([
                mc(vc)
            ])),
            A2(hc, f, s([
                mc("Additional photography is available on my "),
                A2(fc, s([
                    dc("https://www.flickr.com/photos/ortynski/albums"),
                    lc("_blank")
                ]), s([
                    mc("Flickr page")
                ]))
            ]))
        ]));
    }, jc = {
        $: 4
    }, Wc = oc("current-work"), Ic = oc("image-container"), Pc = $a("br"), $c = oc("button"), yc = oc("button-container"), wc = wa, kc = F2(function(a, t) {
        return A2(wc, a, {
            $: 0,
            a: t
        });
    }), Ac = function(a) {
        return A2(kc, "click", gr(a));
    }, xc = function(a) {
        var t = a.bG, r = a.cK;
        return A2(sc, A2($t, Ac(a.cg), A2($t, yc, r)), s([
            A2(sc, s([
                $c
            ]), s([
                mc(t)
            ]))
        ]));
    }, Lc = $a("img"), Ec = function(a) {
        return A2(uc, "src", Ma(a));
    }, Mc = oc("work-with-me-button"), Nc = function(a) {
        return A2(sc, function(a) {
            return s(a ? [
                oc("current-work-container")
            ] : [
                oc("current-work-container"),
                oc("single-column")
            ]);
        }(a), s([
            A2(sc, s([
                Ic
            ]), s([
                A2(Lc, s([
                    Ec("/images/aleksander-and-susan.jpg")
                ]), f)
            ])),
            A2(gc, s([
                Wc
            ]), s([
                mc("Tired of the A.I. hype train?"),
                A2(Pc, f, f),
                A2(Pc, f, f),
                mc("Let's rediscover the satisfaction of capturing authentic memories together")
            ])),
            xc({
                bG: "Work With Me",
                cg: jc,
                cK: s([
                    Mc
                ])
            })
        ]));
    }, Oc = function(a) {
        var t = i(a.bL, a.cA);
        a: for(;;)switch(t.a){
            case 0:
                return !0;
            case 1:
                if (t.b) break a;
                return !0;
            default:
                break a;
        }
        return !1;
    }, Tc = F2(function(a, t) {
        var r, n = a.bM;
        return n.$ || 1 !== n.a ? t : o(t, s([
            (r = Oc(a.bO), A2(sc, function(a) {
                return s(a ? [
                    oc("about-content-container"),
                    oc("single-column")
                ] : [
                    oc("about-content-container")
                ]);
            }(r), s([
                pc(r),
                Nc(r)
            ])))
        ]));
    }), Cc = F2(function(a, t) {
        return a ? A2($t, oc("blur"), t) : t;
    }), _c = oc("contact-content-container"), Rc = F2(function(a, t) {
        return {
            $: 11,
            a: a,
            b: t
        };
    }), Hc = oc("email"), zc = F2(function(a, t) {
        return A2(Fn, function(a) {
            return Ot(a.b);
        }, An(A2(kn, function(t) {
            return r(t.a, a);
        }, t)));
    }), Fc = function(a) {
        return A2(uc, "autocomplete", a ? "on" : "off");
    }, Sc = oc("error-icon"), qc = uc("htmlFor"), Jc = uc("id"), Xc = $a("input"), Yc = oc("input-field"), Zc = F2(function(a, t) {
        return a ? t : A2($t, oc("invalid"), t);
    }), Bc = $a("label"), Vc = $a("span"), Uc = F2(function(a, t) {
        return a ? o(t, s([
            A2(Vc, f, s([
                mc("(required)")
            ]))
        ])) : t;
    }), Kc = oc("tool-tip-text"), Dc = uc("value"), Gc = function(a) {
        var t = a.H, n = a.L, e = a.N, c = a.M, i = a.I, u = a.R;
        return A2(sc, A2(Zc, r(i, Tt), A2($t, Yc, t)), s([
            A2(Bc, s([
                qc(n)
            ]), A2(Uc, c, s([
                A2(sc, f, s([
                    mc(e)
                ]))
            ]))),
            A2(Xc, s([
                Jc(n),
                Fc(!0),
                Dc(u)
            ]), f),
            A2(Vc, s([
                Sc
            ]), s([
                mc("!"),
                A2(Vc, s([
                    Kc
                ]), s([
                    mc(A2(ac, "", A2(Fn, function(a) {
                        return Ot(a);
                    }, i)))
                ]))
            ]))
        ]));
    }, Qc = function(a) {
        return i(a, !0);
    }, ai = F2(function(a, t) {
        return A2(wc, a, {
            $: 1,
            a: t
        });
    }), ti = M, ri = A2(F2(function(a, t) {
        return A3(Tr, _n, t, a);
    }), s([
        "target",
        "value"
    ]), ti), ni = function(a) {
        return A2(ai, "input", A2(sr, Qc, A2(sr, a, ri)));
    }, ei = function(a) {
        var t = a.ar, r = a.aj;
        return Gc({
            H: s([
                Hc,
                ni(Rc(2))
            ]),
            I: A2(zc, 2, t),
            L: "email",
            M: !0,
            N: "Email",
            R: r.bT
        });
    }, ci = oc("first-name"), ii = oc("last-name"), ui = function(a) {
        var t = a.ar, r = a.aj;
        return Gc({
            H: s([
                ii,
                ni(Rc(1))
            ]),
            I: A2(zc, 1, t),
            L: "last-name",
            M: !0,
            N: "Last Name",
            R: r.b9
        });
    }, oi = $a("textarea"), fi = oc("message"), bi = function(a) {
        var t = a.ar, n = a.aj;
        return function(a) {
            var t = a.H, n = a.L, e = a.N, c = a.M, i = a.I, u = a.R;
            return A2(sc, A2(Zc, r(i, Tt), A2($t, Yc, t)), s([
                A2(Bc, s([
                    qc(n)
                ]), A2(Uc, c, s([
                    mc(e)
                ]))),
                A2(oi, s([
                    Jc(n),
                    Fc(!0),
                    Dc(u)
                ]), f),
                A2(Vc, s([
                    Sc
                ]), s([
                    mc("!"),
                    A2(Vc, s([
                        Kc
                    ]), s([
                        mc(A2(ac, "", A2(Fn, function(a) {
                            return Ot(a);
                        }, i)))
                    ]))
                ]))
            ]));
        }({
            H: s([
                fi,
                ni(Rc(3))
            ]),
            I: A2(zc, 3, t),
            L: "message",
            M: !0,
            N: "Message",
            R: n.cg
        });
    }, vi = xc({
        bG: "Submit",
        cg: {
            $: 9
        },
        cK: f
    }), si = oc("title"), gi = A2(sc, s([
        si
    ]), s([
        mc("Name")
    ])), di = F2(function(a, t) {
        var r, n, e, c;
        return o(t, s([
            A2(sc, s([
                (c = Oc(a.bO), oc(c ? "contact-form-container-single-column" : "contact-form-container"))
            ]), s([
                gi,
                (r = a, n = r.ar, e = r.aj, Gc({
                    H: s([
                        ci,
                        ni(Rc(0))
                    ]),
                    I: A2(zc, 0, n),
                    L: "first-name",
                    M: !0,
                    N: "First Name",
                    R: e.b$
                })),
                ui(a),
                ei(a),
                bi(a),
                vi
            ]))
        ]));
    }), hi = function(a) {
        var t;
        return A2(sc, s([
            (t = Oc(a.bO), oc(t ? "contact-description-container-single-column" : "contact-description-container"))
        ]), s([
            A2(hc, f, s([
                mc("\n    Looking to discuss a project? Please get in touch using the form on this page. Generally, I\u2019m able to reply to all inquiries within 48 hours.\n    ")
            ])),
            A2(gc, f, s([
                mc("ortynski@gmail.com"),
                A2(Pc, f, f),
                mc("512-496-6583")
            ]))
        ]));
    }, li = function(a) {
        return A2(sc, A2(Cc, !!a.as, s([
            _c
        ])), A2(di, a, s([
            hi(a)
        ])));
    }, mi = function(a) {
        switch(a){
            case 1:
                return i("Submitting...", "Please wait for the message to be sent.");
            case 3:
                return i("Error", "Please try again later or contact me directly.");
            case 2:
                return i("Success", "Thank you!");
            default:
                return i("", "");
        }
    }, pi = oc("close"), ji = A2(Vc, s([
        pi,
        Ac(zn)
    ]), f), Wi = oc("modal-body"), Ii = oc("modal-content"), Pi = oc("modal-dialog"), $i = oc("title-container"), yi = function(a) {
        switch(a){
            case 1:
                return oc("loading");
            case 3:
                return oc("error");
            case 2:
                return oc("success");
            default:
                return oc("");
        }
    }, wi = F2(function(a, t) {
        return A2(Vc, s([
            $i
        ]), s([
            A2(Vc, s([
                si,
                yi(t)
            ]), s([
                mc(a)
            ]))
        ]));
    }), ki = function(a) {
        var t = a.cV, r = a.cg, n = a.as;
        return A2(sc, s(n ? [
            oc("modal"),
            oc("show")
        ] : [
            oc("modal")
        ]), s([
            A2(sc, s([
                Pi
            ]), s([
                A2(sc, s([
                    Ii
                ]), s([
                    A2(sc, s([
                        Wi
                    ]), s([
                        A2(sc, f, s([
                            A2(wi, t, n),
                            ji,
                            mc(r)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }, Ai = F2(function(a, t) {
        var r = a.as, n = a.bM;
        return n.$ || 2 !== n.a ? t : o(t, s([
            li(a),
            ki({
                as: r,
                cg: mi(r).b,
                cV: mi(r).a
            })
        ]));
    }), xi = function(a) {
        return $a(Ea(a));
    }, Li = function(a) {
        return A3(xi, "style", f, s(a.cf || a.a1 ? [
            mc("body { overflow: hidden; }")
        ] : [
            mc("body { overflow-x: hidden; }")
        ]));
    }, Ei = oc("has-burger-menu"), Mi = F2(function(a, t) {
        return a ? A2($t, Ei, t) : t;
    }), Ni = oc("hide-header"), Oi = F2(function(a, t) {
        return a.b3 ? A2($t, Ni, t) : t;
    }), Ti = oc("animated-transition"), Ci = oc("isScrolling"), _i = F2(function(a, t) {
        var r = a.cY;
        return a.cZ ? A2($t, Ti, t) : r ? A2($t, Ci, t) : t;
    }), Ri = A2(F2(function(a, t) {
        return A2(xa, function(a) {
            return /^(on|formAction$)/i.test(a) ? "data-" + a : a;
        }(a), Ma(t));
    }), "id", "sticky-header"), Hi = oc("header-content"), zi = oc("navigation"), Fi = {
        $: 3
    }, Si = oc("header-item"), qi = oc("header-item--active"), Ji = F2(function(a, t) {
        for(;;){
            if (!t.b) return !1;
            var r = t.b;
            if (a(t.a)) return !0;
            t = r;
        }
    }), Xi = F2(function(a, t) {
        return A2(Ji, function(t) {
            return r(t, a);
        }, t);
    }), Yi = F2(function(a, t) {
        return s(A2(Xi, a.bM, t) ? [
            Si,
            qi
        ] : [
            Si
        ]);
    }), Zi = oc("navigation-item"), Bi = function(a) {
        return A2(sc, s([
            Zi
        ]), s([
            A2(sc, A2($t, Ac(Fi), A2(Yi, a, s([
                Ot(1)
            ]))), s([
                mc("About")
            ]))
        ]));
    }, Vi = {
        $: 2
    }, Ui = oc("bottom-bun"), Ki = oc("burger-box"), Di = oc("burger-inner header-menu-icon-doubleLineHamburger"), Gi = oc("top-bun"), Qi = function(a) {
        var t;
        return A2(sc, s([
            (t = a.cf, oc(t ? "header-burger-btn burger--active" : "header-burger-btn burger")),
            Ac(Vi)
        ]), s([
            A2(sc, s([
                Ki
            ]), s([
                A2(sc, s([
                    Di
                ]), s([
                    A2(sc, s([
                        Gi
                    ]), f),
                    A2(sc, s([
                        Ui
                    ]), f)
                ]))
            ]))
        ]));
    }, au = function(a) {
        return A2(sc, s([
            Zi
        ]), s([
            A2(sc, A2($t, Ac(jc), A2(Yi, a, s([
                Ot(2)
            ]))), s([
                mc("Contact")
            ]))
        ]));
    }, tu = {
        $: 1
    }, ru = {
        $: 0
    }, nu = xa("class"), eu = F2(function(a, t) {
        return A2($t, nu(a ? "work-chevron open" : "work-chevron"), t);
    }), cu = xa("d"), iu = xa("fill"), uu = xa("height"), ou = function(a) {
        return A2(kc, "click", gr(a));
    }, fu = Pa("http://www.w3.org/2000/svg"), bu = fu("path"), vu = fu("svg"), su = xa("viewBox"), gu = xa("width"), du = A2(La, "http://www.w3.org/XML/1998/namespace", "xml:space"), hu = F2(function(a, t) {
        return A2(vu, A2(eu, a, s([
            iu("#ffffff"),
            gu("10px"),
            uu("10px"),
            su("0 0 96.154 96.154"),
            du("preserve"),
            ou(t)
        ])), s([
            A2(bu, s([
                cu("M0.561,20.971l45.951,57.605c0.76,0.951,2.367,0.951,3.127,0l45.956-57.609c0.547-0.689,0.709-1.716,0.414-2.61\n\t\tc-0.061-0.187-0.129-0.33-0.186-0.437c-0.351-0.65-1.025-1.056-1.765-1.056H2.093c-0.736,0-1.414,0.405-1.762,1.056\n\t\tc-0.059,0.109-0.127,0.253-0.184,0.426C-0.15,19.251,0.011,20.28,0.561,20.971z")
            ]), f)
        ]));
    }), lu = oc("dropdown-content"), mu = oc("open"), pu = function(a) {
        var t;
        return A2(sc, s([
            Zi
        ]), s([
            A2(sc, A2($t, Ac(ru), A2(Yi, a, s([
                Ot(0)
            ]))), s([
                mc("Work"),
                A2(sc, (t = a.bx, s(t ? [
                    lu,
                    mu
                ] : [
                    lu
                ])), s([
                    A2(fc, s([
                        dc("#1")
                    ]), s([
                        mc("Portraits")
                    ])),
                    A2(fc, s([
                        dc("#49")
                    ]), s([
                        mc("Theatre")
                    ])),
                    A2(fc, s([
                        dc("#213")
                    ]), s([
                        mc("Festival")
                    ])),
                    A2(fc, s([
                        dc("#16")
                    ]), s([
                        mc("Music")
                    ]))
                ]))
            ])),
            A2(hu, a.bx, tu)
        ]));
    }, ju = function(a) {
        return A2(sc, s([
            zi
        ]), function(a) {
            return Oc(a.bO) ? s([
                Qi(a)
            ]) : s([
                pu(a),
                Bi(a),
                au(a)
            ]);
        }(a));
    }, Wu = oc("logo"), Iu = A2(sc, s([
        Wu,
        Ac(ru)
    ]), s([
        mc(bc)
    ])), Pu = A2(sc, s([
        si
    ]), s([
        Iu
    ])), $u = function(a) {
        return A2(sc, A2(Cc, !!a.as, function(a) {
            return A2(_i, a, A2(Mi, Oc(a.bO), A2(Oi, a, s([
                Ri
            ]))));
        }(a)), s([
            A2(sc, s([
                Hi
            ]), s([
                Pu,
                ju(a)
            ]))
        ]));
    }, yu = oc("header-menu-item"), wu = oc("header-menu-item-container"), ku = oc("header-menu-item-content"), Au = F2(function(a, t) {
        var r;
        return o(t, s([
            A2(sc, s([
                (r = a, oc(r.cf ? "header-menu" : "header-menu closed"))
            ]), s([
                A2(sc, s([
                    wu
                ]), s([
                    A2(sc, s([
                        yu,
                        Ac(ru)
                    ]), s([
                        A2(sc, s([
                            ku
                        ]), s([
                            mc("Work")
                        ]))
                    ])),
                    A2(sc, s([
                        yu,
                        Ac(Fi)
                    ]), s([
                        A2(sc, s([
                            ku
                        ]), s([
                            mc("About")
                        ]))
                    ])),
                    A2(sc, s([
                        yu,
                        Ac(jc)
                    ]), s([
                        A2(sc, s([
                            ku
                        ]), s([
                            mc("Contact")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), xu = F2(function(a, t) {
        var r = i(a.bO.bL, a.bO.cA);
        a: for(;;)switch(r.a){
            case 0:
                return A2(Au, a, t);
            case 1:
                if (r.b) break a;
                return A2(Au, a, t);
            default:
                break a;
        }
        return t;
    }), Lu = function(a) {
        var t = a.bM;
        if (t.$) return bc;
        var r = t.a;
        return o(function() {
            switch(r){
                case 0:
                    return "";
                case 1:
                    return "About - ";
                default:
                    return "Contact - ";
            }
        }(), bc);
    }, Eu = F2(function(a, t) {
        a: for(;;){
            if (a > 0) {
                if (t.b) {
                    a -= 1, t = t.b;
                    continue a;
                }
                return t;
            }
            return t;
        }
    }), Mu = F2(function(a, t) {
        return t * a;
    }), Nu = F3(function(a, t, r) {
        for(;;){
            if (0 >= t) return a;
            a = A2($t, r, a), t -= 1;
        }
    }), Ou = F2(function(a, t) {
        return A3(Nu, f, a, t);
    }), Tu = function(a) {
        return A3(Ht, Nt, 0, a);
    }, Cu = F3(function(a, t, r) {
        return Tu(A2(yn, A2(Ou, zt(r), t), A2(Cr, Mu(a), r)));
    }), _u = F5(function(a, t, r, n, c) {
        a: for(;;){
            if (n.b) {
                if (n.b.b) {
                    u = n.a;
                    var i = n.b;
                    if (1 > e(A3(Cu, a, t, c), r)) {
                        n = i, c = o(c, s([
                            u
                        ]));
                        continue a;
                    }
                    return c;
                }
                var u = n.a;
                return 1 > e(A3(Cu, a, t, c), r) ? o(c, s([
                    u
                ])) : c;
            }
            return f;
        }
    }), Ru = F4(function(a, t, r, n) {
        return A5(_u, a, t, r, n, f);
    }), Hu = F2(function(a, t) {
        return a * (zt(t) - 1);
    }), zu = F4(function(a, t, r, n) {
        return A2(Yn, a, Zn((r - A2(Hu, t, n)) / Tu(n)));
    }), Fu = F4(function(a, t, r, n) {
        return A2(Ou, zt(n), A4(zu, a, t, r, n));
    }), Su = F4(function(a, t, r, n) {
        if (n.b) {
            var e = A4(Fu, a, t, r, A4(Ru, a, t, r, n));
            return o(e, A4(Su, a, t, r, A2(Eu, zt(e), n)));
        }
        return f;
    }), qu = function(a) {
        var t = a.c1.c$.c0 * a.ab.b1, r = A4(Su, a.ab.bs, a.ab.aY, t, A2(Cr, function(a) {
            return a.aI;
        }, a.b4));
        return 1 > t ? f : A3(Ht, F2(function(n, c) {
            var u = c.a, f = c.b, b = u.a, v = u.b, g = A2(ac, 0, An(A2(Eu, zt(f), r))), d = n.aI * g;
            if (0 > e(b, t)) return i(i(b + d + a.ab.aY, v), o(f, s([
                u
            ])));
            var h = v + A2(ac, 0, An(A2(Eu, zt(f) - 1, r))) + a.ab.aY, l = i(d + a.ab.aY, h);
            return i(l, o(f, s([
                i(0, h)
            ])));
        }), i(i(0, 0), f), a.b4).b;
    }, Ju = x, Xu = F4(function(a, t, r, n) {
        if (n.b) {
            if (n.b.b) {
                var e = A4(Ru, a, t, r, n);
                return A4(zu, a, t, r, e) + A4(Xu, a, t, r, A2(Eu, zt(e), n)) + t;
            }
            return A4(zu, a, t, r, A4(Ru, a, t, r, n));
        }
        return 0;
    }), Yu = function(a) {
        return {
            $: 13,
            a: a
        };
    }, Zu = $a("figure"), Bu = F3(function(a, t, r) {
        var n = a.aW, c = a.c4;
        return 1 > e(r + .1 * n, c + n) && e(r + .1 * n + t, c) > -1;
    }), Vu = oc("lazy-image"), Uu = oc("lazy-loaded-image"), Ku = ka, Du = F4(function(a, t, r, n) {
        var e, c, u = a.c$, o = r.b;
        return A2(Zu, s([
            A2(Ku, "transform", "translate(" + Ju(r.a) + "px, " + Ju(o) + "px)"),
            A2(Ku, "height", Ju(n) + "px"),
            A2(Ku, "width", Ju(n * t.aI) + "px"),
            Ac((c = t.cc, {
                $: 5,
                a: c
            }))
        ]), s([
            (e = i(t.cd, A3(Bu, u, n, o)), A2(Lc, s(e.a ? [
                Jc(_t(t.av)),
                Ec(t.bv),
                Uu
            ] : e.b ? [
                Jc(_t(t.av)),
                Ec(t.bv),
                A2(kc, "load", gr(Yu(t))),
                Vu
            ] : [
                Jc(_t(t.av)),
                Vu
            ]), f))
        ]));
    }), Gu = d, Qu = oc("page-secton"), ao = $a("section"), to = F2(function(a, t) {
        return r(a.bM, Ot(0)) ? o(t, function(a) {
            var t, r = a.b4, n = a.c1.c$.c0 * a.ab.b1, e = A2(Cr, function(a) {
                return a.aI;
            }, r), c = Ju(A4(Xu, a.ab.bs, a.ab.aY, n, e));
            return s([
                A2(ao, s([
                    Qu
                ]), s([
                    A2(sc, A2($t, A2(Ku, "height", c + "px"), (t = Oc(a.bO), s(t ? [
                        oc("gallery-strips")
                    ] : [
                        oc("gallery-strips"),
                        oc("wider")
                    ]))), A4(Gu, F3(function(t, r, n) {
                        return A4(Du, a.c1, t, r, n);
                    }), r, qu(a), A4(Su, a.ab.bs, a.ab.aY, n, e)))
                ]))
            ]);
        }(a)) : t;
    }), ro = {
        $: 6
    }, no = $a("button"), eo = A2(vu, s([
        su("0 0 40 40")
    ]), s([
        A2(bu, s([
            cu("M4.3,35.7L35.7,4.3")
        ]), f),
        A2(bu, s([
            cu("M4.3,4.3l31.4,31.4")
        ]), f)
    ])), co = {
        $: 7
    }, io = {
        $: 8
    }, uo = xa("points"), oo = fu("polyline"), fo = xa("stroke-miterlimit"), bo = A2(vu, s([
        su("0 0 9 16")
    ]), s([
        A2(oo, s([
            iu("none"),
            fo("10"),
            uo("7.3,14.7 2.5,8 7.3,1.2")
        ]), f)
    ])), vo = function(a) {
        return oc(a ? "lightbox-control right" : "lightbox-control left");
    }, so = oc("lightbox-control-btn"), go = oc("lightbox-controls"), ho = A2(vu, s([
        su("0 0 9 16")
    ]), s([
        A2(oo, s([
            iu("none"),
            fo("10"),
            uo("1.6,1.2 6.5,7.9 1.6,14.7")
        ]), f)
    ])), lo = F2(function(a, t) {
        return a.bO.bL ? o(t, s([
            A2(sc, s([
                go
            ]), s([
                A2(sc, s([
                    vo(0),
                    Ac(co)
                ]), s([
                    A2(no, s([
                        so
                    ]), s([
                        bo
                    ]))
                ])),
                A2(sc, s([
                    vo(1),
                    Ac(io)
                ]), s([
                    A2(no, s([
                        so
                    ]), s([
                        ho
                    ]))
                ]))
            ]))
        ])) : t;
    }), mo = oc("lightbox-background"), po = oc("lightbox-close-btn"), jo = oc("lightbox-close-btn-icon"), Wo = oc("lightbox-header"), Io = oc("lightbox-item"), Po = oc("lightbox-item-src"), $o = oc("lightbox-wrapper"), yo = oc("selected"), wo = F2(function(a, t) {
        return a ? A2($t, yo, t) : t;
    }), ko = F4(function(a, t, n, e) {
        return A2(Xi, a, s([
            Ot(n.cc),
            Ot(n.cc + 1),
            Ot(n.cc - 1)
        ])) || r(a, Ot(0)) && r(n.cc, t - 1) || r(a, Ot(t - 1)) && !n.cc ? o(e, s([
            i(_t(n.av), A2(Zu, s([
                Io
            ]), s([
                A2(sc, s([
                    $o
                ]), s([
                    A2(sc, s([
                        Po
                    ]), s([
                        A2(Lc, A2(wo, r(a, Ot(n.cc)), s([
                            Ec(n.bv)
                        ])), f)
                    ]))
                ]))
            ])))
        ])) : e;
    }), Ao = oc("lightbox-list"), xo = function(a) {
        return ya(Ea(a));
    }, Lo = F2(function(a, t) {
        var r, n, e;
        return a.a1 ? o(t, s([
            A2(sc, s([
                (e = a.a1, oc(e ? "lightbox open" : "lightbox"))
            ]), s([
                A2(sc, s([
                    mo
                ]), f),
                A2(sc, s([
                    Wo
                ]), s([
                    A2(no, s([
                        po
                    ]), s([
                        A2(sc, s([
                            jo,
                            Ac(ro)
                        ]), s([
                            eo
                        ]))
                    ]))
                ])),
                A2(sc, s([
                    $o
                ]), A2(lo, a, s([
                    A3(xo, "div", s([
                        Ao
                    ]), (r = a, n = r.b4, A3(Ht, A2(ko, r.cJ, zt(n)), f, n)))
                ])))
            ]))
        ])) : t;
    }), Eo = xa("id"), Mo = F2(function(a, t) {
        return a ? A2($t, nu("isScrolling"), t) : t;
    }), No = F2(function(a, t) {
        return A2(vu, A2(Mo, a, s([
            Eo("scrollToTheTop"),
            gu("40px"),
            uu("40px"),
            su("0 0 438.533 438.533"),
            ou(t)
        ])), s([
            A2(bu, s([
                iu("#ffffff"),
                cu("M409.133,109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736,9.801,259.058,0,219.273,0\n\t\tc-39.781,0-76.47,9.801-110.063,29.407c-33.595,19.604-60.192,46.201-79.8,79.796C9.801,142.8,0,179.489,0,219.267\n\t\tc0,39.78,9.804,76.463,29.407,110.062c19.607,33.592,46.204,60.189,79.799,79.798c33.597,19.605,70.283,29.407,110.063,29.407\n\t\ts76.47-9.802,110.065-29.407c33.593-19.602,60.189-46.206,79.795-79.798c19.603-33.596,29.403-70.284,29.403-110.062\n\t\tC438.533,179.485,428.732,142.795,409.133,109.203z M361.74,259.517l-29.123,29.129c-3.621,3.614-7.901,5.424-12.847,5.424\n\t\tc-4.948,0-9.236-1.81-12.847-5.424l-87.654-87.653l-87.646,87.653c-3.616,3.614-7.898,5.424-12.847,5.424\n\t\tc-4.95,0-9.233-1.81-12.85-5.424l-29.12-29.129c-3.617-3.607-5.426-7.898-5.426-12.847c0-4.942,1.809-9.227,5.426-12.848\n\t\tl129.62-129.616c3.617-3.617,7.898-5.424,12.847-5.424s9.238,1.807,12.846,5.424L361.74,233.822\n\t\tc3.613,3.621,5.424,7.905,5.424,12.848C367.164,251.618,365.357,255.909,361.74,259.517z")
            ]), f),
            A2(bu, s([
                iu("#000000"),
                cu("M 361.74,259.52 L 332.62,288.65 C 329,292.26 324.72,294.07 319.77,294.07 314.82,294.07 310.53,292.26 306.92,288.65 L 219.27,200.99 131.62,288.65 C 128.01,292.26 123.73,294.07 118.78,294.07 113.83,294.07 109.54,292.26 105.93,288.65 L 76.81,259.52 C 73.19,255.91 71.38,251.62 71.38,246.67 71.38,241.73 73.19,237.44 76.81,233.82 L 206.43,104.21 C 210.04,100.59 214.32,98.78 219.27,98.78 224.22,98.78 228.51,100.59 232.12,104.21 L 361.74,233.82 C 365.35,237.44 367.16,241.73 367.16,246.67 367.16,251.62 365.36,255.91 361.74,259.52 Z M 361.74,259.52")
            ]), f)
        ]));
    }), Oo = F2(function(a, t) {
        return o(t, s([
            A2(No, a.c1.c$.c4 > 50, ru)
        ]));
    }), To = $a("h2"), Co = oc("tag-line-grid"), _o = oc("tag-line-link"), Ro = F2(function(a, t) {
        return r(a.bM, Ot(0)) ? A2(Oo, a, function(a) {
            return o(a, s([
                A2(ao, s([
                    Qu
                ]), s([
                    A2(sc, s([
                        Co
                    ]), s([
                        A2(To, f, s([
                            mc(bc + " is a professional photographer in Austin, TX. Have a project in mind? "),
                            A2(Vc, s([
                                _o,
                                Ac(jc)
                            ]), s([
                                mc("Let's work together.")
                            ]))
                        ]))
                    ]))
                ]))
            ]));
        }(A2(Lo, a, A2(to, a, t)))) : t;
    });
    Le = {
        Main: {
            init: (Me = (Ee = {
                b7: Tn,
                cw: function(a) {
                    return {
                        $: 15,
                        a: a
                    };
                },
                cx: function(a) {
                    return {
                        $: 16,
                        a: a
                    };
                },
                cQ: function() {
                    return Hn(Br);
                },
                cX: ic,
                c_: function(a) {
                    return {
                        bE: s([
                            A2(sc, f, A2(xu, a, A2(Ai, a, A2(Tc, a, A2(Ro, a, s([
                                Li(a),
                                $u(a)
                            ]))))))
                        ]),
                        cV: Lu(a)
                    };
                }
            }).cw, Ne = Ee.cx, Oe = function() {
                Oe.a(Me(et()));
            }, rt({
                aB: function(a) {
                    return Oe.a = a, ot.addEventListener("popstate", Oe), 0 > ot.navigator.userAgent.indexOf("Trident") || ot.addEventListener("hashchange", Oe), F2(function(t, r) {
                        if (!(r.ctrlKey || r.metaKey || r.shiftKey || r.button >= 1 || t.target || t.hasAttribute("download"))) {
                            r.preventDefault();
                            var n = t.href, e = et(), c = Lr(n).a;
                            a(Ne(c && e.be === c.be && e.aX === c.aX && e.ba.a === c.ba.a ? {
                                $: 0,
                                a: c
                            } : function(a) {
                                return {
                                    $: 1,
                                    a: a
                                };
                            }(n)));
                        }
                    });
                },
                b7: function(a) {
                    return A3(Ee.b7, a, et(), Oe);
                },
                c_: Ee.c_,
                cX: Ee.cX,
                cQ: Ee.cQ
            }))(gr(0))(0)
        }
    }, a.Elm ? function a(t, r) {
        for(var n in r)n in t ? "init" == n ? m(6) : a(t[n], r[n]) : t[n] = r[n];
    }(a.Elm, Le) : a.Elm = Le;
}($a0b4f895e1596b3b$exports);


// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $6b528e0c36449ff5$var$isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $6b528e0c36449ff5$export$6503ec6e8aabbaf(config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener('load', ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($6b528e0c36449ff5$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $6b528e0c36449ff5$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $6b528e0c36449ff5$var$registerValidSW(swUrl, config);
        });
    }
}
function $6b528e0c36449ff5$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function $6b528e0c36449ff5$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $6b528e0c36449ff5$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function $6b528e0c36449ff5$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}


const $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root")
});
// Scrolling Logic for the dynamic header:
var $35da740d59af89ba$var$_window = window;
var $35da740d59af89ba$var$_document = $35da740d59af89ba$var$_window.document;
var $35da740d59af89ba$var$_body = $35da740d59af89ba$var$_document.body;
var $35da740d59af89ba$var$_html = $35da740d59af89ba$var$_document.documentElement;
var $35da740d59af89ba$var$scrollTimer = null;
var $35da740d59af89ba$var$lastScrollFireTime = 0;
var $35da740d59af89ba$var$minScrollTime = 200;
function $35da740d59af89ba$var$scrollOrResize(event) {
    event.returnValue = false;
    if ($35da740d59af89ba$var$scrollTimer) ;
    else {
        var now = new Date().getTime();
        if (now - $35da740d59af89ba$var$lastScrollFireTime > 3 * $35da740d59af89ba$var$minScrollTime) {
            $35da740d59af89ba$var$processScrollOrResize();
            $35da740d59af89ba$var$lastScrollFireTime = now;
        }
        $35da740d59af89ba$var$scrollTimer = setTimeout(function() {
            $35da740d59af89ba$var$scrollTimer = null;
            $35da740d59af89ba$var$lastScrollFireTime = new Date().getTime();
            $35da740d59af89ba$var$processScrollOrResize();
        }, $35da740d59af89ba$var$minScrollTime);
    }
}
document.body.onscroll = $35da740d59af89ba$var$scrollOrResize;
document.body.onresize = $35da740d59af89ba$var$scrollOrResize;
var $35da740d59af89ba$var$processScrollOrResize = function() {
    var screenData = {
        scrollTop: parseInt(window.pageYOffset || $35da740d59af89ba$var$_html.scrollTop || $35da740d59af89ba$var$_body.scrollTop || 0),
        pageHeight: parseInt(Math.max(document.body.scrollHeight, document.body.offsetHeight, $35da740d59af89ba$var$_html.clientHeight, $35da740d59af89ba$var$_html.scrollHeight, $35da740d59af89ba$var$_html.offsetHeight)),
        viewportHeight: parseInt($35da740d59af89ba$var$_html.clientHeight),
        viewportWidth: parseInt($35da740d59af89ba$var$_html.clientWidth)
    };
    var Viewport = {
        scene: {
            height: screenData.pageHeight,
            width: screenData.viewportWidth
        },
        viewport: {
            height: screenData.viewportHeight,
            width: screenData.viewportWidth,
            x: 0,
            y: screenData.scrollTop
        }
    };
    $35da740d59af89ba$var$app.ports.messageReceiver.send(Viewport);
};
// Disable right click on all images
document.addEventListener("contextmenu", function(event) {
    if (event.target.tagName === "IMG") event.preventDefault();
});
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$6b528e0c36449ff5$export$d07f55d4c15c0440();


//# sourceMappingURL=photography-website.73f84a5e.js.map
